{
  "A11Y": {
    "TRANSLATABLE_FORM_TAB_ARIA_LABEL": "Onglets de sélection de langue du formulaire"
  },
  "ACCESS_CONTROL": {
    "WITHOUT_RIGHT_PERMISSIONS": "Vous n’avez pas les droits suffisants pour accéder à cette page."
  },
  "ADD_TO_CALENDAR": {
    "TITLE": "Calendrier",
    "URL_WITH_EVENT": "{description} \n Rejoindre la visioconférence : {url}"
  },
  "ANONYMOUS": "Anonyme",
  "API_SAUCE": {
    "CANCEL_ERROR": "La requête serveur a été interrompue.",
    "CLIENT_ERROR": "Oups, une erreur inattendue s’est produite.",
    "CONNECTION_ERROR": "Le serveur est indisponible.",
    "NETWORK_ERROR": "Erreur réseau, vérifiez votre connexion.",
    "SERVER_ERROR": "Oups, une erreur inattendue s’est produite.",
    "TIMEOUT_ERROR": "Le serveur n’a pas répondu à temps."
  },
  "ARTICLE": {
    "NOT_PUBLISHED": "Non publié",
    "PUBLICATION_ALERT": "Planifié le {date} à {time}."
  },
  "ASSIGNMENT_CARD": {
    "AVATAR_ALT": "Photo du responsable",
    "TITLE": "Responsable"
  },
  "ASSIGNMENT_MODAL": {
    "CHOOSE_ADMIN": "Choisissez un administrateur",
    "TITLE": "Assigner le traitement de cette contribution"
  },
  "ATTACHMENTS": {
    "ERROR": {
      "DELETE_FAILED": "Nous n’avons pas pu effacer cette pièce jointe.",
      "TITLE": "Erreur - "
    }
  },
  "ATTENDANCE": {
    "ATTEND": "Je participe",
    "ATTENDING": "Inscrit"
  },
  "AUTH": {
    "ACCEPT_SPACE_PRIVACY": "J’accepte la <terms>politique de confidentialité</terms> de {spaceName}.",
    "ACCEPT_SPACE_TERMS": "J’accepte les <privacy>conditions d’utilisation</privacy> de {spaceName}.",
    "ACCEPT_SPACE_TERMS_AND_PRIVACY": "J’accepte <privacy>la politique de confidentialité</privacy> et <terms>les conditions d’utilisation</terms> de {spaceName}.",
    "ACCEPT_TERMS_AND_PRIVACY": "J’accepte la {privacy} et les {terms} de Fluicity Engage.",
    "ARIA_AUTHENTICATE_WITH": "S’inscrire avec {provider}",
    "AUTH_LIST_TITLE": "Services d’authentification tiers",
    "BACKGROUND_ALT": "Illustration de fond",
    "CONTINUE_WITHOUT_SIGNUP": "Continuer sans compte",
    "DELETE_TOAST": "Le service d’authentification tiers a bien été déconnecté",
    "DESCRIPTION": "Votre inscription sur Fluicity Engage vous permettra de participer aux consultations sur {spaceName} et vous donnera accès aux autres consultations organisées sur Fluicity Engage. Pour en savoir plus sur la gestion de vos données personnelles et pour exercer vos droits, consultez notre <b>Politique de Confidentialité.</b>",
    "EMAIL_PLACEHOLDER": "exemple@email.com",
    "ENTITY_SUBSCRIPTION_FORM": {
      "CONTENT": "En rejoignant <strong>{spaceName}</strong>, vous serez informé des dernières consultations et actualités.<br></br><br></br>Vous pouvez également aider à mieux comprendre si l’activité est représentative de la population globale en partageant quelques informations :",
      "TITLE": "Rejoindre {spaceName} !"
    },
    "ERRORS": {
      "CANNOT_DELETE_WITHOUT_PASSWORD": "Configurez un mot de passe pour supprimer ce service d’authentification tiers.",
      "DELETE_AUTH_FAILED": "Nous n’avons pas pu supprimer ce service d’authentification tiers.",
      "INVALID_EMAIL": "Le format de votre adresse e-mail est incorrect.",
      "NO_ASSOCIATED_ACCOUNT": "Aucun compte n’est associé.",
      "REQUIRED_CHECKBOX": "Vous devez cocher cette case.",
      "REQUIRED_EMAIL": "Vous devez renseigner une adresse e-mail.",
      "REQUIRED_FIRST_NAME": "Vous devez renseigner un prénom.",
      "REQUIRED_LAST_NAME": "Vous devez renseigner un nom.",
      "REQUIRED_PASSWORD": "Vous devez renseigner un mot de passe.",
      "SHORT_PASSWORD": "Le mot de passe doit faire {count} caractères minimum."
    },
    "FACEBOOK_LOAD_ERROR": "Il semble qu’une extension activée sur votre navigateur nous empêche d’utiliser l’authentification Facebook. Veuillez désactiver l’extension si vous souhaitez utiliser cette fonctionnalité.",
    "FIRST_NAME_PLACEHOLDER": "Exemple : Jean",
    "FORGOT_PASSWORD": "Mot de passe oublié ?",
    "HAS_ACCOUNT": "Déjà un compte ?",
    "HAS_SIGNED_IN": "Vous êtes connecté à {spaceName} !",
    "LAST_NAME_PLACEHOLDER": "Exemple : Dupont",
    "LOGIN": "Se connecter",
    "NAME_PREVIEW": "Les autres utilisateurs vous verront en tant que :",
    "NO_ACCOUNT": "Pas encore de compte ?",
    "OAUTH_BUTTONS": {
      "CSAM": "Rejoindre avec CSAM"
    },
    "PAGE_TITLE": "Se connecter",
    "SIGNUP": "Créer un compte",
    "SIGNUP_EXTRAS": {
      "DESCRIPTION": "Aidez-nous à mieux comprendre si l’activité de la plateforme est représentative de la population globale. Ces informations seront utilisées uniquement à des fins de vérification de la légitimité des participants et de statistiques en lien avec la participation.",
      "PAGE_TITLE": "Dernière étape !",
      "WELCOME_TOAST": "Félicitations, vous avez rejoint {spaceName} !"
    },
    "UNLINK": "Déconnecter",
    "VERIFY_EMAIL": {
      "CONTENT": "Entrer le code de vérification reçu sur {email}.",
      "RESEND": "Vous n’avez par reçu d’email ? {link}",
      "RESEND_LINK": "Renvoyer le code",
      "RESEND_SUCCESS": "Un nouveau code de vérification vous a été envoyé.",
      "TITLE": "Vérifier son compte",
      "VERIFY_ALERT": "Vérifiez votre adresse email pour participer à l’ensemble des consultations.",
      "VERIFY_SUCCESS": "Votre compte a bien été vérifié."
    }
  },
  "BACK": "Précédent",
  "BUTTONS": {
    "ACCEPT": "Accepter",
    "ACCESS_CONSULTATION": "Accéder à la consultation",
    "ACTIONS": "Actions",
    "ADD": "Ajouter",
    "ADD_ATTACHMENTS": "Ajouter des fichiers/images",
    "ADD_NEW_IDEA": "Contributions",
    "CANCEL": "Annuler",
    "CHANGE_USER": "Changer d’utilisateur",
    "CLEAR": "Effacer",
    "CLONE": "Dupliquer",
    "CLOSE": "Fermer",
    "COMMENT": "Commenter",
    "CONFIRM": "Confirmer",
    "CONTINUE": "Continuer",
    "DELETE": "Supprimer",
    "DELETE_VOTERS": "Supprimer les votants",
    "DRAG_DROP_ATTACHMENTS": "Glisser-déposer des fichiers/images ici ou cliquer",
    "EXPORT": "Exporter",
    "EXPORT_PARTICIPANTS": "Exporter les participants",
    "EXPORT_PROPOSALS": "Exporter les contributions",
    "EXPORT_RESULTS": "Exporter les résultats",
    "EXPORT_VOTERS": "Exporter les votants",
    "FILTER": "Filtrer",
    "IGNORE": "Pas maintenant",
    "IMPORT": "Importer",
    "IMPORT_VIA_EXCEL": "Importer un fichier Excel",
    "IMPORT_VIA_FORM": "Remplir le formulaire en ligne",
    "IMPORT_VOTERS": "Importer des votants",
    "IN_PROGRESS": "En cours…",
    "JOIN": "Rejoindre",
    "LEARN_MORE": "En savoir plus",
    "NO": "Non",
    "OPEN": "Ouvrir",
    "OPEN_IN_NEW_TAB": "Ouvre un nouvel onglet",
    "PUBLISH": "Publier",
    "READ_MORE": "Voir plus",
    "REJECT_ALL": "Rejeter tout",
    "SAVE": "Enregistrer",
    "SETTINGS": "Paramètres",
    "SKIP": "Passer",
    "TRANSLATE_VIA_AI": "Traduire via l’IA",
    "UPDATE": "Modifier",
    "UPDATE_PICTURE": "Modifier",
    "UPLOAD_PICTURE": "Ajouter une photo",
    "VERIFY": "Vérifier",
    "VERIFY_EMAIL": "Vérifier mon adresse email",
    "VIEW_ANSWER": "Voir la réponse",
    "VIEW_IDEAS": "Voir les contributions",
    "VOTE": {
      "BUDGET": "Je soutiens",
      "NOT_SUPPORT": "Je ne soutiens pas",
      "SUPPORT": "Je soutiens",
      "TOAST": {
        "CANCEL": "Votre vote a bien été supprimé",
        "SUCCESS": "Votre vote a bien été enregistré"
      },
      "VOTE_AGAINST": "Je vote contre",
      "VOTE_FOR": "Je vote pour"
    },
    "WRITE": "Écrire"
  },
  "CHILDREN_COUNT": "{count, plural, =0 {Aucun contenu} one {{count} contenu} other {{count} contenus}}",
  "COMMENTS": {
    "AUTHOR": "Auteur",
    "CREATE": {
      "PRIVACY_WARNING": "Ce contenu est confidentiel. Seuls l’auteur et l’organisation destinataire peuvent le visualiser.",
      "SUBMIT": "Envoyer"
    },
    "CREATION": {
      "APPEND_COMMENT": {
        "IDEA": "Laisser un commentaire public pour expliquer le changement de statut"
      },
      "ERROR": "Vous devez remplir correctement les champs.",
      "PLACEHOLDER": "Votre commentaire",
      "SUCCESS_ANOMALY": "Votre réponse à été envoyée.",
      "SUCCESS_DEMAND": "Votre réponse a été envoyée.",
      "SUCCESS_IDEA": "Votre commentaire a été publié.",
      "VALIDATE": "Valider"
    },
    "SHOW": {
      "BE_THE_FIRST_TO_COMMENT_CONSULTATION": "Soyez le premier à commenter !",
      "BE_THE_FIRST_TO_COMMENT_MESSAGING": "Cet utilisateur attend votre réponse depuis le {date}.",
      "BE_THE_FIRST_TO_COMMENT_PARTICIPATION": "Soyez le premier à commenter !",
      "CONTRIBUTION_ENDED": "La consultation est terminée",
      "CONTRIBUTION_ENDED_ON": "La consultation s’est terminée le {date}",
      "CONTRIBUTION_HAS_NOT_STARTED": "La consultation commence le {date}",
      "COUNT_CONSULTATION": "{count, plural, =0 {Aucun commentaire} one {{count} Commentaire} other {{count} Commentaires}}",
      "COUNT_MESSAGING": "{count, plural, =0 {Aucune réponse} one {{count} Réponse} other {{count} Réponses}}",
      "COUNT_PARTICIPATION": "{count, plural, =0 {Aucun commentaire} one {{count} Commentaire} other {{count} Commentaires}}"
    },
    "THREAD": {
      "DELETED_COMMENT": "Ce commentaire a été effacé.",
      "DISPLAY_CONVERSATION": "{count, plural, =0 {Aucune réponse} one {Voir {count} réponse} other {Voir {count} réponses}}",
      "REPLY": "Répondre"
    },
    "TITLE": "Commentaires"
  },
  "CONTRAST_RATIO": {
    "DESCRIPTION": "Un contraste suffisant permet d’assurer un niveau d’accessibilité acceptable pour vos utilisateurs. Conformément aux recommandations internationales (WCAG) et à celles du Référentiel général d’amélioration de l’accessibilité (RGAA) nous vous conseillons de choisir une couleur ayant un contraste d’au moins {ratio}:1 (correspondant au niveau AA du standard WCAG version 2.1)",
    "TEXT": {
      "BAD": "Le niveau de contraste pour cette couleur est de {value}:1, ne permettant pas d’être conforme aux recommandations en terme d’accessibilité (WCAG niveau AA)",
      "GOOD": "Le niveau de contraste pour cette couleur est de {value}:1 et est conforme aux recommandations en terme d’accessibilité (WCAG niveau AA)"
    }
  },
  "COOKIES_SETTINGS": {
    "SSO_AUTH_MODAL": {
      "CONTENT": "{providerName} va déposer des cookies sur votre machine si vous utilisez cette fonctionnalité."
    },
    "VIDEO_PLACEHOLDER": {
      "ADS_BLOCK": "Vous avez activé un bloqueur de publicité qui empêche l’affichage de cette vidéo. Veuillez le désactiver pour continuer.",
      "CTA": "Accepter les cookies",
      "VIMEO": "Vimeo souhaite déposer des cookies pour afficher la vidéo",
      "YOUTUBE": "Youtube souhaite déposer des cookies pour afficher la vidéo"
    }
  },
  "DASHBOARD": {
    "BUTTONS": {
      "EXPORT": {
        "CONSULTATION": "Exporter les contributions",
        "MESSAGING": "Exporter",
        "PARTICIPATION": "Exporter"
      }
    },
    "COUNTERS": {
      "ASSIGNMENT": "{count, plural, =0 {Aucune assignation} one {{count} Assignation} other {{count} Assignations}}",
      "COMMUNICATION": "{count, plural, =0 {Aucune actualité} one {{count} Actualité} other {{count} Actualités}}",
      "CONSULTATION": "{count, plural, =0 {Aucune consultation} one {{count} Consultation} other {{count} Consultations}}",
      "FOLDER": "{count, plural, =0 {Aucun dossier} one {{count} Dossier} other {{count} Dossiers}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Aucun contenu} one {{count} Contenu} other {{count} Contenus}}",
      "FORM_RESPONSES": "{count, plural, =0 {Aucune réponse} one {{count} Réponse} other {{count} Réponses}}",
      "INVITATIONS": "{count, plural, =0 {Aucune invitation} one {{count} invitation} other {{count} invitations}}",
      "MESSAGING": "{count, plural, =0 {Aucun contenu} one {{count} Contenu} other {{count} Contenus}}",
      "NEWSLETTERS": "{count, plural, =0 {Aucune newsletter} one {{count} newsletter} other {{count} newsletters}}",
      "PARTICIPATION": "{count, plural, =0 {Aucune contribution} one {{count} Contribution} other {{count} Contributions}}",
      "RANKING": "Classement des contributions",
      "USER": "{count, plural, =0 {Aucun utilisateur} one {{count} Utilisateur} other {{count} Utilisateurs}}",
      "VOTERS": "{count, plural, =0 {Aucun votant} one {{count} Votant} other {{count} Votants}}"
    },
    "COUNTERS_SELECTED": {
      "COMMUNICATION": "{count, plural, =0 {Aucune actualité sélectionnée} one {{count} Actualité sélectionnée} other {{count} Actualités sélectionnées}}",
      "CONSULTATION": "{count, plural, =0 {Aucune consultation sélectionnée} one {{count} Consultation sélectionnée} other {{count} Consultations sélectionnées}}",
      "FOLDER": "{count, plural, =0 {Aucun dossier sélectionné} one {{count} Dossier sélectionné} other {{count} Dossiers sélectionnés}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Aucun contenu sélectionné} one {{count} Contenu sélectionné} other {{count} Contenus sélectionnés}}",
      "MESSAGING": "{count, plural, =0 {Aucun contenu sélectionné} one {{count} Contenu sélectionné} other {{count} Contenus sélectionnés}}",
      "PARTICIPATION": "{count, plural, =0 {Aucune contribution sélectionnée} one {{count} Contribution sélectionnée} other {{count} Contributions sélectionnées}}",
      "VOTERS": "{count, plural, =0 {Aucun votant sélectionné} one {{count} Votant sélectionné} other {{count} Votants sélectionnés}}"
    },
    "EDIT": "Modifier",
    "EMPTY_STATE": {
      "ASSIGNMENT": "Vous retrouverez ici les contenus qui vous sont assignés",
      "COMMUNICATION": "Publiez votre première actualité",
      "CONSULTATION": "Publiez votre première consultation",
      "FOLDER": "Créez votre premier dossier",
      "FOLDER_CONTENT": "Vous retrouverez ici les contenus du dossier",
      "FORM_RESPONSES": "Vous retrouverez ici les réponses au questionnaire",
      "INVITATIONS": "Vous retrouverez ici la liste des invitations.",
      "MESSAGING": "Vous retrouverez ici les messages et anomalies",
      "NEWSLETTER": "Créez votre première newsletter",
      "PARTICIPATION": "Vous retrouverez ici les contributions de la consultation",
      "SEARCH": {
        "BUTTON": "Réinitialiser les filtres",
        "DESCRIPTION": "Vérifiez que vous avez bien orthographié votre recherche ou modifiez les filtres.",
        "TITLE": "Aucun résultat"
      },
      "USER": "Vous retrouverez ici la liste des utilisateurs inscrits.",
      "VOTERS": "Vous retrouverez ici les votants de la consultation"
    },
    "FILTERS": {
      "ADDRESS_CITY": {
        "LABEL": "Commune",
        "PLACEHOLDER": "Filtrer par commune"
      },
      "BLANK": "Non renseigné",
      "FOLDER": {
        "LABEL": "Dossier",
        "PLACEHOLDER": "Filtrer par dossier"
      },
      "NEWSLETTER_STATUS": {
        "DRAFT": "Brouillon",
        "SCHEDULED": "Planifiée",
        "SENT": "Envoyée"
      },
      "PROF_CATEGORY": {
        "LABEL": "Catégorie socio-professionnelle",
        "PLACEHOLDER": "Filtrer par catégorie socio-professionnelle"
      },
      "REGISTERED": {
        "LABEL": "Inscrit",
        "PLACEHOLDER": "Filtrer par inscription",
        "REGISTERED": "Inscrit",
        "UNREGISTERED": "Non inscrit"
      },
      "ROLES": {
        "ADMINISTRATOR": "Administrateur",
        "AUTHOR": "Auteur",
        "CITIZEN": "Utilisateur",
        "CONTRIBUTOR": "Gestionnaire",
        "LABEL": "Role",
        "PLACEHOLDER": "Filtrer par role"
      },
      "SEX": {
        "LABEL": "Sexe",
        "PLACEHOLDER": "Filtrer par sexe"
      },
      "STATUS": {
        "ANSWERED": "Non retenue",
        "DOING": "Analyse en cours",
        "DONE": "Concrétisée",
        "DUPLICATE": "Regroupée",
        "IN_PROGRESS": "Réalisation en cours",
        "LABEL": "Statut",
        "MESSAGING": {
          "DOING": "Analyse en cours",
          "DONE": "Réponse apportée",
          "LABEL": "Statut",
          "PLACEHOLDER": "Filtrer par statut",
          "TODO": "Déposée"
        },
        "PLACEHOLDER": "Filtrer par statut",
        "PLANNED": "Planifiée",
        "REJECTED": "Refusée",
        "SELECTED": "Retenue",
        "TODO": "Déposée",
        "TO_MODERATE": "À modérer",
        "VALIDATED": "Lauréate"
      },
      "TAG": {
        "LABEL": "Thématique",
        "PLACEHOLDER": "Filtrer par thématique"
      },
      "TYPES": {
        "ANOMALY": "Anomalie",
        "ARTICLE": "Article",
        "COLLABORATIVE_DECISION": "Concertation",
        "DEMAND": "Message",
        "EVENT": "Événement",
        "FOLDER": "Dossier",
        "IDEA": "Contribution",
        "IDEAS_REQUEST": "Appel à contributions",
        "LABEL": "Type de contenu",
        "PARTICIPATORY_BUDGET": "Budget participatif",
        "PLACEHOLDER": "Filtrer par type",
        "STUDY": "Questionnaire",
        "SURVEY": "Questionnaire"
      },
      "USER_TYPE": {
        "DESCRIPTION": "En ligne ou hors ligne",
        "LABEL": "Participation",
        "OFFLINEUSER": "Hors ligne",
        "PLACEHOLDER": "Filtrer par type de participation",
        "USER": "En ligne"
      },
      "VISIBILITY": {
        "DRAFT": "Non publié",
        "LABEL": "Visiblité",
        "PLACEHOLDER": "Filtrer par visibilité",
        "PLANNED": "Planifié",
        "PUBLISHED": "Publié"
      }
    },
    "MANAGE_FILTERS": {
      "DESCRIPTION": "Les filtres sont enregistrés pour tous les administrateurs et gestionnaires autorisés.",
      "NO_FILTERABLE_QUESTIONS": "Aucun filtre disponible.",
      "SECTION_TITLE_FORM": "Information du formulaire",
      "SECTION_TITLE_PARTICIPANTS": "Profil des participants",
      "TITLE": "Filtrer"
    },
    "MENU": {
      "ASSIGNMENT": "Assignations",
      "COMMUNICATION": "Actualités",
      "CONSULTATION": "Consultations",
      "FOLDER": "Dossiers",
      "GENERAL": "Général",
      "MESSAGING": "Messagerie",
      "NEWSLETTER": "Newsletters",
      "PARTICIPATION": "Participation",
      "SETTINGS": "Paramètres",
      "SETTINGS_ACCESS": "Accès",
      "SETTINGS_COMMUNICATION": "Communication",
      "SETTINGS_GENERAL": "Général",
      "SETTINGS_LEGAL": "Textes légaux",
      "SETTINGS_PAGES": "Pages",
      "STATS": "Aperçu",
      "USER": "Utilisateurs"
    },
    "NEWSLETTERS": "Newsletters",
    "PARTICIPATION": "Participation",
    "POSTS_FORM": {
      "FIELDS_CONFIG": {
        "ACTIVE": "Activer",
        "APPLICATION_FILE_LABEL": "Importer un modèle de fichier détaillé de candidature",
        "APPLICATION_FILE_TOOLTIP": "Pour demander des informations complémentaires aux utilisateurs lors de la soumission d’une nouvelle contribution, vous pouvez leur fournir un modèle de fichier détaillé de candidature.<br></br><b>Formats acceptés :</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
        "DESCRIPTION": "Le formulaire de dépôt correspond aux informations que l’utilisateur va devoir remplir pour déposer sa contribution.",
        "REQUIRED": "Obligatoire",
        "TITLE": "Formulaire de dépôt"
      },
      "SETTINGS_PANEL": {
        "COMMUNICATION": {
          "TITLE": "Paramètres de l’actualité"
        },
        "CONSULTATION": {
          "TITLE": "Paramètres de la consultation"
        },
        "FOLDER": {
          "TITLE": "Paramètres du dossier"
        }
      },
      "TABS": {
        "ANALYSIS": "Analyse",
        "APPEARANCE": "Général",
        "DISABLED_TOOLTIP": "Remplissez et enregistrez le formulaire actuel pour accéder à celui-ci",
        "IMPLEMENTATION": "Résultats",
        "MANAGERS": "Gestionnaires",
        "PRESENTATION": "Présentation",
        "PUBLIC_FILTERS": "Filtres publics",
        "QUESTIONS": "Questions",
        "SECURITY": "Sécurité",
        "SETTINGS": "Paramètres",
        "SUBMISSION": "Dépôt",
        "VOTE": "Vote"
      }
    },
    "PUBLIC_FILTERS": {
      "DESCRIPTION": "Ajouter une recherche avancée à votre consultation pour permettre à vos utilisateurs de filtrer les contributions sur votre page.",
      "TITLE": "Filtres publics"
    },
    "SHOW": "Voir",
    "TABLE": {
      "ARIA_LABELS": {
        "FIRST_PAGE": "Première page",
        "LAST_PAGE": "Dernière page",
        "NEXT_PAGE": "Page suivante",
        "PREVIOUS_PAGE": "Page précédente"
      },
      "BUTTONS": {
        "ACTIONS": "Actions",
        "CHANGE_STATUS": "Changer le statut",
        "DELETE": "Supprimer"
      },
      "PAGINATION": "{from}-{to} sur {count}",
      "TITLES": {
        "ACTIONS": "Actions",
        "ASSIGNED": "Responsable",
        "AUTHOR": "Auteur",
        "BIRTHDATE": "Date de naissance",
        "BUDGET": "Coût",
        "COMMENTS_COUNT": "Commentaires",
        "COMMUNICATIONS_COUNT": "Actualités",
        "CONSULTATION": "Consultation",
        "CONSULTATIONS_COUNT": "Consultations",
        "CONSULTATION_TITLE": "Titre de la consultation",
        "CONTRIBUTION": "Contribution",
        "CREATED_AT": "Date d’invitation",
        "EMAIL": "E-mail",
        "FIRST_NAME": "Prénom",
        "FOLDER": "Dossier",
        "FOLDERS_COUNT": "Dossiers",
        "HAS_ACCESS": "Accès ?",
        "ID": "ID",
        "IDEAS_COUNT": "Contributions",
        "LAST_NAME": "Nom",
        "LAST_VOTE_AT": "Date du vote",
        "NEWSLETTER_CREATED_AT": "Date de création",
        "NEWSLETTER_SENT_AT": "Date d’envoi",
        "NEWSLETTER_SUBJECT": "Sujet",
        "NEWSLETTER_TITLE": "newsletter",
        "PARTICIPATION_TYPE": "Participation",
        "PICTURE": " ",
        "PUBLICATION_DATE": "Publié le",
        "RECIPIENTS": "Destinataires",
        "RESPONSE_DATE": "Date",
        "ROLE": "Rôle",
        "SENT_AT": "Date d’envoi",
        "SOURCE": "Participation",
        "STATE": "État",
        "STATUS": "Statut",
        "SUBSCRIPTION_DATE": "Date d’inscription",
        "TITLE": "Titre",
        "TOPIC": "Thématique",
        "TYPE": "Type",
        "USER": "Utilisateur",
        "VISIBILITY": "Visibilité",
        "VOTES_AGAINST_COUNT": "Votes contre",
        "VOTES_COUNT": "Nombre de votes",
        "VOTES_FOR_COUNT": "Votes pour"
      }
    }
  },
  "DATE": {
    "INPUT_FORMAT": "DD/MM/YYYY"
  },
  "DATE_TIME": {
    "DAYS_LEFT": "{count, plural, =0 {Dernier jour !} one {Il reste {count} jour !} other {Il reste {count} jours !}}",
    "INVALID_LABEL": "Invalide",
    "IN_N_DAYS": "Début {count}",
    "LABEL": {
      "DEFAULT": "Choisir une date",
      "SCHEDULE_LABEL": "Publier le",
      "SCHEDULE_TITLE": "Planifier la publication"
    }
  },
  "DISCUSSION": {
    "EMAIL": {
      "CONTENT": {
        "LABEL": "Contenu de l’e-mail",
        "PLACEHOLDER": "Bonjour, …"
      },
      "DELETED_USER_WARNING": "Cet utilisateur a souhaité supprimer son compte. Vous ne pouvez donc pas le contacter.",
      "SEND": "Envoyer",
      "SUBJECT": {
        "LABEL": "Sujet de l’e-mail",
        "PLACEHOLDER": "Demande d’informations complémentaires à propos de …"
      }
    },
    "SHOW": {
      "COMMENTS_COUNT": "{count, plural, =0 {Note privée} one {{count} Note privée} other {{count} Notes privées}}",
      "COMMENT_PLACEHOLDER": {
        "PRIVATE": "Ajouter une note privée",
        "PUBLIC": "Votre commentaire"
      },
      "INFO": "Veillez à ne pas rédiger de commentaires contenant des données considérées comme sensibles.",
      "INFO_TOOLTIP": "Origine raciale ou ethnique, opinions politiques, philosophiques ou religieuses, appartenance syndicale, données de santé, préférence sexuelle, casier judiciaire, …",
      "NO_COMMENTS": "Soyez le premier à écrire une note privée"
    }
  },
  "DUPLICATED_POSTS": {
    "TITLE": "{count, plural, =0 {# contributions similaires regoupées avec celle-ci} one {{count} contribution similaire regoupée avec celle-ci} other {{count} contributions similaires regoupées avec celle-ci}}"
  },
  "ERROR_PAGES": {
    "BACK_TO_SPACE": "Retourner à l’accueil",
    "CTA_NO_SPACE": "Trouver un espace de participation",
    "FORMER_CLIENT_TOAST": "L’espace que vous essayez de visiter n’existe pas ou plus.",
    "NOT_FOUND": {
      "DESCRIPTION": "Il semble que nous vous ayons fait emprunter un mauvais chemin. On repart sur de bonnes bases ?",
      "TITLE": "Désolé, nous n’avons pas trouvé la page que vous cherchiez."
    },
    "OFFLINE": {
      "DESCRIPTION": "Il semble que vous êtes hors ligne. Commençons par rafraîchir ?",
      "TITLE": "Désolé, nous n’avons pas trouvé la page que vous cherchiez."
    },
    "RELOAD": "Rafraîchir",
    "SERVER_ERROR": {
      "DESCRIPTION": "Soyez assuré que nos développeurs mettent tout en oeuvre pour la réparer. Nous devrions être de retour d’ici peu.",
      "TITLE": "Oups, une erreur inattendue s’est produite."
    }
  },
  "FOOTER": {
    "ACCESSIBILITY": "Accessibilité",
    "ETHICAL_POLICY": "Charte éthique",
    "HELP": "Aide",
    "LEGAL_NOTICE": "Mentions légales",
    "PRIVACY_POLICY": "Politique de confidentialité",
    "TERMS_OF_USE": "Conditions d’utilisation"
  },
  "FORM": {
    "ERRORS": {
      "FILL_CORRECTLY": "Vous devez remplir correctement les champs.",
      "REQUIRED": "Vous devez remplir ce champ."
    },
    "SELECT_EMPTY_LABEL": "Non spécifié",
    "TOASTS": {
      "DELETED_SUCCESSFULLY": "Suppression effectuée avec succès",
      "UPDATED_SUCCESSFULLY": "Mise à jour effectuée avec succès"
    }
  },
  "FORM_RESPONSES": {
    "CREATED_AT": "Répondu le <b>{date}</b> à <b>{time}</b>",
    "SHOW_RESPONSE": "Voir ma réponse",
    "SUBMISSION_NOT_ONGOING": "La consultation est clôturée, vous ne pouvez plus répondre ou modifier votre réponse.",
    "UPDATE_RESPONSE": "Modifier ma réponse"
  },
  "GENERIC_CONFIRM_DELETE": {
    "CONTENT": "Êtes-vous certain de vouloir supprimer cet élément ?",
    "CTA": "Oui, supprimer",
    "TITLE": "Supprimer"
  },
  "HOME": {
    "PAGE_TITLE": "Bienvenue sur Fluicity Engage",
    "SEARCH_PLACEHOLDER": "Entrez le nom de l’espace",
    "SUBTITLE": "Trouvez un espace pour commencer à participer"
  },
  "IMAGE": {
    "FAILED_TO_LOAD": "Échec du chargement de l'image",
    "LOADING": "Chargement de l'image"
  },
  "IMPORT": {
    "CONTRIBUTIONS": {
      "HEADLINE": {
        "DESCRIPTION": "Pour ajouter plusieurs contributions reçues en dehors de la plateforme, {link} sans en modifier le format.<br></br>Si vous n’avez pas récoltés certaines informations, merci de ne pas supprimer les colonnes et de les laisser vide.<br></br>Si vos contributions sont en plusieurs langues, merci de toutes les traduire dans {defaultLang} avant de les importer.",
        "LINK": "remplissez le modèle",
        "TITLE": "Importer des contributions"
      },
      "STATUS": {
        "DESCRIPTION": "Indiquer le statut des contributions lors de l’import",
        "TITLE": "Choisir le statut"
      }
    },
    "ERROR": {
      "DESCRIPTION": "Impossible d’importer votre fichier. Vérifiez que votre fichier respecte bien le modèle.",
      "EXPLANATION": "Vérifiez qu’aucune colonne n’a été supprimée et que les réponses respectent le format demandé.",
      "ROWS_MULTIPLE": "Impossible d'importer votre fichier. Des erreurs ont été identifiées lignes {rows}.",
      "ROWS_SINGLE": "Impossible d'importer votre fichier. Une erreur a été identifiée ligne {rows}.",
      "ROWS_WITH_MORE": "Impossible d'importer votre fichier. Des erreurs ont été identifiées lignes {rows} et {moreCount} autres."
    },
    "FORM": {
      "CTA": "Importer",
      "UPLOAD_DATE": "{size} - Mise à jour le {date}",
      "UPLOAD_TITLE": "Glisser le fichier ou cliquer"
    },
    "FORM_RESPONSES": {
      "HEADLINE": {
        "DESCRIPTION": "Pour ajouter plusieurs réponses reçues en dehors de la plateforme, {link} sans en modifier le format.<br></br>Si vous n’avez pas récoltés certaines informations, merci de ne pas supprimer les colonnes et de les laisser vide.<br></br>Si vos réponses sont en plusieurs langues, merci de toutes les traduire dans {defaultLang} avant de les importer.",
        "LINK": "remplissez le modèle",
        "TITLE": "Importer des réponses"
      }
    },
    "PREVIEW": {
      "DESCRIPTION": "Vérifiez que les informations de votre import correspondent aux colonnes du modèle.<br></br>Si des informations ne correspondent pas, vous devez modifier votre fichier puis importer votre fichier mis à jour.",
      "TITLE": "Vérifier les données"
    },
    "PROGRESS": "Import en cours…",
    "VOTERS": {
      "HEADLINE": {
        "DESCRIPTION": "Pour ajouter des votes reçus en dehors de la plateforme, {link} sans en modifier le format. Si vous n’avez pas récoltés certaines informations, merci de <b>ne pas supprimer les colonnes</b> et de les laisser vide.",
        "LINK": "remplissez le modèle",
        "TITLE": "Importer des votes"
      }
    }
  },
  "JOIN": "Rejoindre",
  "JOINED_SPACE": "Vous avez rejoint {space}, bienvenue !",
  "KEEP_ME_ALIVE": {
    "ALERT": {
      "CONTENT": "Nous vous tiendrons au courant si des consultations pertinentes pour vous sont diffusées à l’avenir. Vous pouvez également retrouver d’autres espaces existants en utilisant la recherche ci-dessous et en vous connectant avec votre compte actuel.",
      "CONTENT_NOT_FOUND": "Afin de participer à nouveau à une consultation, merci de recréer un compte.",
      "TITLE": "Merci d’avoir choisi de garder votre compte actif !",
      "TITLE_NOT_FOUND": "Votre compte n’existe plus ou à déjà été anonymisé !"
    }
  },
  "LOADING_MORE": "Chargement…",
  "LOAD_MORE": "Voir plus",
  "MENU_ITEMS": {
    "DESCRIPTION": "Personnaliser les onglets qui apparaissent dans votre barre de navigation.",
    "FORM": {
      "ADD_ITEM": "Ajouter un onglet",
      "ADD_SUBITEM": "Ajouter un sous-onglet",
      "INPUTS": {
        "LABEL": {
          "LABEL": "Libellé",
          "PLACEHOLDER": "Indiquer le libellé de votre onglet"
        },
        "LINK": {
          "LABEL": "Lien externe",
          "PLACEHOLDER": "https://site.com"
        },
        "PAGE": {
          "LABEL": "Page par défaut",
          "PLACEHOLDER": "Sélectionner une page"
        },
        "POST": {
          "LABEL": "Contenu",
          "NO_OPTIONS": "Aucun contenu trouvé",
          "PLACEHOLDER": "Rechercher un contenu"
        },
        "POST_CATEGORY": {
          "COMMUNICATION": "Actualités",
          "CONSULTATION": "Consultations",
          "FOLDER": "Dossier",
          "LABEL": "Type de contenu",
          "PLACEHOLDER": "Sélectionner un type de contenu"
        },
        "TYPE": {
          "LABEL": "Type",
          "PLACEHOLDER": "Sélectionner un type"
        }
      }
    },
    "GROUP": "Menu déroulant",
    "LINK": "Lien externe",
    "NEW_GROUP": "NOUVEAU MENU DÉROULANT",
    "NEW_ITEM": "NOUVEAU ÉLÉMENT",
    "PAGE": "Page par défaut",
    "PAGE_ABOUT": "À propos",
    "PAGE_CONSULTATIONS": "Consultations",
    "PAGE_NEWS": "Actualités",
    "PAGE_SEARCH": "Rechercher",
    "POST": "Contenu",
    "TITLE": "Votre barre de navigation"
  },
  "MESSAGING_BLOC": {
    "ANOMALY": {
      "REPORT_CTA": "Signaler une anomalie"
    },
    "DEMAND": {
      "REPORT_CTA": "Envoyer un message"
    }
  },
  "META_TAGS": {
    "DEFAULT_DESCRIPTION": "Fluicity Engage est une solution d’engagement citoyen, qui permet la prise de décision collective autour des sujets d’intérêt général.",
    "PAGES_TITLES": {
      "ABOUT": "À propos | {spaceName}",
      "CONSULTATIONS": "Consultations | {spaceName}",
      "CONTRIBUTIONS": {
        "MESSAGING": "Mes messages & anomalies | {spaceName}",
        "PROPOSALS": "Mes contributions | {spaceName}"
      },
      "DASHBOARD": "Tableau de bord | {spaceName}",
      "LEGAL_NOTICE": "Mention légales | {spaceName}",
      "NEWS": "Actualités | {spaceName}",
      "PRIVACY_POLICY": "Politique de confidentialité |{spaceName}",
      "SEARCH": "Recherche | {spaceName}",
      "SETTINGS": "Mon compte | {spaceName}",
      "TERMS_OF_USE": "Conditions d’utilisation | {spaceName}"
    },
    "STATUS_TO_SHARE": {
      "ARTICLE": "{cityName} : découvrez cet article sur Fluicity Engage !",
      "EVENT": "{cityName} : participez à cet événement !",
      "FOLDER": "{title} {url}",
      "IDEA": "Soutenez cette contribution : {title} {url}"
    },
    "TITLE_TO_SHARE": {
      "FOLDER": "{title}",
      "IDEA": "Soutenez cette contribution : {title}"
    }
  },
  "MODERATION": {
    "MODAL": {
      "DESCRIPTION": "Vous pouvez modifier votre contribution ou la soumettre en l'état. Les services évalueront si votre contribution peut être publiée ou non.",
      "REASON": "Raison:",
      "SUBMIT": "Soumettre",
      "TITLE": "Votre contribution a été identifiée suspecte."
    }
  },
  "MOMENT": {
    "DATE": {
      "DEFAULT": "DD/MM/YYYY",
      "PLACEHOLDER": "JJ/MM/AAAA"
    }
  },
  "NAVBAR": {
    "DASHBOARD": "Tableau de bord",
    "MY_ACCOUNT": "Mon compte",
    "MY_PROFILE": "Mon profil"
  },
  "NEWSLETTERS": {
    "ALREADY_SENT": "Cette newsletter a déjà été envoyée",
    "CREATED_AT": "Créée le <b>{date}</b> à <b>{time}</b>",
    "DRAFT": "Brouillon",
    "FORM": {
      "CLEAR_SCHEDULING": "Annulation de la planification.",
      "CONTENT": {
        "LABEL": "Contenu",
        "PLACEHOLDER": "Contenu de l’email"
      },
      "RECIPIENTS": {
        "ALL": "Tous les utilisateurs",
        "LABEL": "Destinataires",
        "PLACEHOLDER": "Sélectionnez les destinataires"
      },
      "SAVE_SUCCESS": "Votre newsletter a été enregistrée avec succès",
      "SCHEDULE": "Planifier l’envoi",
      "SCHEDULED_AT": "Date d’envoi",
      "SEND": "Envoyer",
      "SEND_SUCCESS": "Votre newsletter a été envoyée avec succès",
      "SEND_TEST": "Envoyer le test",
      "SUBJECT": {
        "LABEL": "Sujet",
        "PLACEHOLDER": "Sujet de l’email"
      },
      "TEST_EMAIL": {
        "LABEL": "Adresses email de test",
        "PLACEHOLDER": "Saisissez les adresses email de test (séparées par des virgules)"
      },
      "TEST_SUCCESS": "Votre newsletter de test a été envoyée avec succès"
    },
    "IMMEDIATELY": "Immédiatement",
    "NEW_NEWSLETTER": "Créer une newsletter",
    "SCHEDULED": "Planifiée",
    "SENT": "Envoyée",
    "SENT_AT": "Envoyée le <b>{date}</b> à <b>{time}</b>",
    "UPDATE_NEWSLETTER": "Modifier la newsletter",
    "USERS_FILTER_COUNT": "{count, plural, =0 {Aucun destinataire n’a été trouvé pour cette sélection} one {Votre newsletter sera envoyée à 1 personne} other {Votre newsletter sera envoyée à {count} personnes}}"
  },
  "NEXT": "Suivant",
  "NONE": "Aucun",
  "NOTIFICATIONS_SETTINGS": {
    "ADMINISTRATOR": {
      "DAILY_DIGEST": {
        "DESCRIPTION": "Consultations :<br />• Nouvelles contributions<br />• Nouvelle réponses aux enquêtes<br />• Lorsqu’un citoyen répond à un de mes commentaires<br />• Lorsqu’une phase ou une consultation se termine bientôt<br /><br />Messagerie :<br />• Nouveaux messages<br />• Nouvelles anomalies<br />• Lorsqu’un citoyen répond à un de mes commentaires",
        "SUBTITLE": " (quotidien)",
        "TITLE": "Dernières activités"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Modification d’une contribution par son auteur<br />• Modération d’un contenu par l’équipe Fluicity Engage",
        "TITLE": "Autres"
      }
    },
    "CITIZEN": {
      "CONSULTATIONS_NOTIFICATIONS": {
        "DESCRIPTION": "• Nouvelle consultation<br />• Début d’une phase d’idéation, de vote ou de résultats",
        "TITLE": "Consultations"
      },
      "DAILY_DIGEST": {
        "DESCRIPTION": "• Commentaire ou vote sur ma contribution<br />• Réponse à mon commentaire<br />• Changement de statut de ma contribution",
        "SUBTITLE": " (quotidien)",
        "TITLE": "Vos dernières activités"
      },
      "NEWSLETTER_NOTIFICATIONS": {
        "DESCRIPTION": "• Newsletters concernant l’activité de la plateforme",
        "TITLE": "Newsletters"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Supression d’une contribution que vous avez commentée<br />• Modération d’un contenu que vous avez commenté",
        "TITLE": "Autres"
      },
      "WEEKLY_DIGEST": {
        "DESCRIPTION": "• Nouveaux articles<br />• Nouveaux événements<br />• Contributions à la une",
        "SUBTITLE": " (hebdomadaire)",
        "TITLE": "En ce moment sur l’espace"
      }
    },
    "INFO_BOX_TEXT": "Sélectionnez ici les notifications email que vous souhaitez recevoir de la part de la plateforme."
  },
  "NPS_FORM": {
    "CONTENT_FIELD": "Pourquoi ?",
    "EXTREMELY_LIKELY": "Tout à fait",
    "NOT_LIKELY": "Pas du tout",
    "TITLE": "Aidez-nous à améliorer Fluicity Engage",
    "VALUE_QUESTION": "Recommanderiez-vous Fluicity Engage à un pair ?"
  },
  "OFFLINE": "Hors ligne",
  "ONLINE": "En ligne",
  "OR": "OU",
  "ORIGINAL_POST": {
    "NO_OPTIONS": "Aucune contribution ne peut être sélectionnée",
    "TITLE": "Cette contribution a été regroupée avec la contribution similaire suivante"
  },
  "PAGE_OF": "Page {current} sur {total}",
  "PASSWORD_RESET": {
    "ACTION": "mettre à jour",
    "ARIA_LABEL": "Basculer la visibilité du mot de passe",
    "PAGE_TITLE": "Créer un nouveau mot de passe",
    "TITLE": "Créer un nouveau mot de passe",
    "TOAST": "Le nouveau mot de passe a été enregistré."
  },
  "PASSWORD_RESET_REQUEST": {
    "HOMEPAGE_LINK": "Revenir à la page d’accueil",
    "LINK_SENT": "Si un compte est associé à l’e-mail <strong>{email}</strong>, vous recevrez un lien de réinitialisation. <br></br><br></br>Si vous ne voyez pas de mail, vérifiez dans votre courrier indésirable.",
    "PAGE_TITLE": "Réinitialiser votre mot de passe",
    "RESET": "Réinitialiser",
    "SUB_TITLE": "Vous avez oublié votre mot de passe ? Ça arrive à tout le monde ! Nous allons vous envoyer un e-mail avec un lien pour le réinitialiser.",
    "TITLE": "Réinitialiser votre mot de passe"
  },
  "PICTURE_PICKER": {
    "COVER": "Choisissez une image pour illustrer votre publication"
  },
  "POSTS": {
    "AUDITS": {
      "CREATE": "créé {date}",
      "MODAL": {
        "AFTER": "Après modification",
        "BEFORE": "Avant modification",
        "TITLE": "Historique"
      },
      "NO_AUDITS": "Cette contribution n’a pas encore était mise à jour.",
      "UPDATE": "Mis à jour {date}"
    },
    "AUTHOR": "Auteur",
    "BUDGET": {
      "ALERT": "Vous devez <b>renseigner le coût</b> de la contribution avant de la définir comme “Retenue”.",
      "BUDGET_VALUE": "Cette contribution coûte <b>{budget}</b>",
      "MODAL_LABEL": "Coût de la contribution",
      "MODAL_TITLE": "Renseigner le coût",
      "NOT_ENOUGH_BUDGET": "Le budget restant est insuffisant.",
      "NOT_SELECTED": "Cette contribution n’a pas été retenue pour la phase de vote",
      "REMAINING_BUDGET": "Il vous reste <strong>{remaining}</strong> à dépenser"
    },
    "CARD": {
      "CONTRIBUTE": "Contribuer",
      "PARTICIPATE": "Participer",
      "READ_MORE": "Consulter",
      "VOTE": "Voter"
    },
    "CAROUSEL": {
      "PROGRESS": {
        "TOOLTIP_1": "{progress, plural, =0 {{progress} vote} one {{progress} vote} other {{progress} votes}}",
        "TOOLTIP_2": "{total, plural, =0 {sur {total} contribution} one {sur {total} contribution} other {sur {total} contributions}}"
      },
      "PROMPT": {
        "PROPOSAL_CARD": {
          "CTA": "Contribution",
          "TEXT_1": "Ou si vous avez de l’inspiration",
          "TEXT_2": "on fait une contribution ?"
        },
        "VOTE_CARD": {
          "CTA": "Voter",
          "TEXT_1": "Vous avez déjà parcouru quelques contributions {emoji}",
          "TEXT_2": "on continue ?",
          "TEXT_3": "ou voir la liste complète"
        }
      }
    },
    "CLONE": {
      "ACTION": "Dupliquer",
      "CANCEL": "Non",
      "CONFIRM": "Oui, dupliquer",
      "CONTENT_CLONED": "Ce contenu a bien été dupliqué.",
      "DESCRIPTION": "Souhaitez-vous vraiment dupliquer ce contenu ?",
      "SUCCESS": "Ce contenu a été supprimé."
    },
    "COMMENTS_COUNT": "{count, plural, =0 {Commentaire} one {Commentaire} other {Commentaires}}",
    "CONSULTATIONS": {
      "BE_THE_FIRST_TO_PARTICIPATE": "Soyez le ou la première à participer !",
      "CONSULTATIONS_COUNT": "{count, plural, =0 {{count} consultation} one {{count} consultation} other {{count} consultations}}",
      "ENDED_AT": "La consultation s’est terminée le {date}",
      "FEED_TITLE": {
        "IDEAS_COUNT": "{itemCount, plural, =0 {Aucune contribution} one {# contribution} other {# contributions} }",
        "LOCATED_IDEAS_COUNT": "{itemCount, plural, =0 {Aucune contribution localisée} one {1 contribution localisée} other {# contributions localisées}}"
      },
      "MAP_TOOLTIP": "Les contributions non géolocalisées n’apparaissent pas sur la carte. Une contribution peut avoir plusieurs localisations.",
      "NEWS_COUNT": "{count, plural, =0 {actualité} one {{count} actualité} other {{count} actualités}}",
      "ONGOING_TEXT": "Rendez-vous ici pour participer.",
      "PARTICIPATE_OFF": "Rendez-vous ici prochainement pour contribuer aux contributions !",
      "POST_SIDE_PRIMARY_ACTION": {
        "IMPLEMENTATION": "Découvrez les résultats",
        "PARTICIPATE": "Participez à la consultation"
      },
      "SEE_OWN_VOTES": "Voir uniquement mes votes",
      "STARTS_AT": "La consultation commence le {date}",
      "STEP_ENDED_AT": "La phase “{step}” s’est terminée le {date}",
      "STEP_STARTS_AT": "Rendez-vous le {date} pour découvrir la phase “{step}”"
    },
    "CONTENT_DELETED_SUCCESSFULLY": "le contenu a été supprimé",
    "CREATE_MENU": {
      "ACTIONS": "Actions",
      "ADDED_TO_FOLDER_TOAST": "Contenu ajouté au dossier.",
      "ADD_TO_FOLDER": "Ajouter à un dossier",
      "ARTICLE": {
        "DESCRIPTION": "Présenter une actualité ou une initiative"
      },
      "ASSIGN": "Assigner",
      "BUTTON": "Créer",
      "COLLABORATIVE_DECISION": {
        "DESCRIPTION": "Mettre en oeuvre des contributions co-construites avec les utilisateurs"
      },
      "CONTACT_AUTHOR": "Contacter l’auteur",
      "DIALOG_TITLE": {
        "COMMUNICATION": "Créer une actualité",
        "CONSULTATION": "Créer une consultation"
      },
      "EDIT": "Modifier",
      "EVENT": {
        "DESCRIPTION": "Inviter à participer à une rencontre"
      },
      "FOLDER": {
        "DESCRIPTION": "Créer une page pour centraliser des contenus"
      },
      "IDEAS_REQUEST": {
        "DESCRIPTION": "Recueillir des contributions sur vos enjeux stratégiques"
      },
      "MERGE": "Regrouper la contribution",
      "PARTICIPATORY_BUDGET": {
        "DESCRIPTION": "Affecter un budget à des contributions co-construites avec les utilisateurs"
      },
      "PIN": "Mettre à la Une",
      "REMOVED_FROM_FOLDER_TOAST": "Contenu retiré du dossier.",
      "REPORT": "Signaler",
      "STEPS_COUNT": "{count, plural, one {# étape} other {# étapes}}",
      "STUDY": {
        "DESCRIPTION": "Intégrer une enquête créée en dehors de la plateforme",
        "TITLE": "Questionnaire - Intégration"
      },
      "SURVEY": {
        "DESCRIPTION": "Interroger les utilisateurs sur un sujet précis et recueillir des informations nuancées"
      },
      "UNPIN": "Ne plus mettre à la une",
      "UNPUBLISH": "Dépublier",
      "UPDATE_BUDGET": "Renseigner le budget",
      "UPDATE_STATUS": "Changer le statut",
      "VIEW": "Voir la publication",
      "VIEW_IN_DASHBOARD": "Tableau de bord",
      "VIEW_POST": "Voir la publication"
    },
    "DELETE": {
      "ACTION": "Supprimer",
      "CANCEL": "Non",
      "CONFIRM": "Oui, supprimer",
      "CONTENT_DELETED": "Ce contenu a été supprimé.",
      "DESCRIPTION": "Souhaitez-vous vraiment supprimer ce contenu ?",
      "PLACEHOLDER": "Ajoutez un commentaire pour détailler votre suppression.",
      "REASON": "Commentaire",
      "SELECT_REASON": "Indiquez pourquoi vous supprimez ce contenu :",
      "SUCCESS": "Ce contenu a été supprimé."
    },
    "DETAILS": {
      "AUTHORED_BY": "Porté par {name}",
      "DESCRIPTION_TITLE": "Description",
      "EVENT": {
        "ACCESS_THE_EVENT": "Accéder à l’événement",
        "EVENT_URL": "Visioconférence",
        "STATE": {
          "FUTURE": "L’événement commence le <b>{date}</b> à <b>{time}</b>.",
          "ONGOING": "L’événement est en cours",
          "PAST": "L’événement est terminé"
        }
      },
      "MORE_TAGS": "{count, plural, one {et une autre thématique} other {et {count} autres thématiques}}",
      "STUDY": {
        "JOIN_BUTTON": "Rejoindre",
        "JOIN_DESCRIPTION": "Connectez-vous ou inscrivez-vous pour accéder à la consultation !",
        "PARTICIPATE": "Participer",
        "POST_SIDE_DESCRIPTION": {
          "COMING": "La consultation commence le {date}.",
          "ENDED": "La consultation s’est terminée le {date}.",
          "ONGOING_ANSWERED": "Merci pour votre participation, elle a bien été prise en compte."
        },
        "SEE_RESULTS": "Voir les résultats"
      },
      "UPDATE_MY_IDEA": "Modifier"
    },
    "EXPORT": {
      "BUTTON": "Exporter",
      "IDEAS": "Toutes les contributions",
      "MESSAGES": "Tous les messages"
    },
    "FILTER_BY_IS_PINNED": "À la une",
    "FILTER_BY_PUBLISHED": "Publié",
    "FILTER_BY_STATUS": "Statut",
    "FILTER_BY_TAGS": "Thématique",
    "FILTER_BY_TYPE": "Type de contenu",
    "FILTER_IS_PINNED_TRUE": "Oui",
    "FILTER_PUBLISHED_FALSE": "Non publié",
    "FILTER_PUBLISHED_TRUE": "Publié",
    "FILTER_STATUS_ANSWERED": "Non retenue",
    "FILTER_STATUS_DOING": "Analyse en cours",
    "FILTER_STATUS_DONE": "Concrétisée",
    "FILTER_STATUS_IN_PROGRESS": "Réalisation en cours",
    "FILTER_STATUS_SELECTED": "Retenue",
    "FILTER_STATUS_TODO": "Déposée",
    "FILTER_STATUS_VALIDATED": "Lauréate",
    "FILTER_TYPE_ANOMALY": "Anomalie",
    "FILTER_TYPE_ARTICLE": "Article",
    "FILTER_TYPE_COLLABORATIVE_DECISION": "Concertation",
    "FILTER_TYPE_DEMAND": "Message",
    "FILTER_TYPE_EVENT": "Evénement",
    "FILTER_TYPE_FOLDER": "Dossier",
    "FILTER_TYPE_IDEA": "Contribution",
    "FILTER_TYPE_IDEAS_REQUEST": "Appel à contributions",
    "FILTER_TYPE_PARTICIPATORY_BUDGET": "Budget participatif",
    "FILTER_TYPE_STUDY": "Questionnaire",
    "FOLDER": {
      "IS_OPEN_TO_PROPOSITIONS": "Ouvert aux contributions spontanées"
    },
    "FORM": {
      "ADDRESS": {
        "LABEL": "Lieu",
        "PLACEHOLDER": "Ajouter un lieu"
      },
      "CATEGORIES": {
        "LABEL": "Thématiques",
        "PLACEHOLDER": "Sélectionnez les thématiques de la consultation",
        "SELECT_ALL": "Tout sélectionner"
      },
      "CATEGORY": {
        "LABEL": "Thématique",
        "PLACEHOLDER": "Sélectionnez une thématique"
      },
      "CONTENT": "Description",
      "PICTURE": {
        "BUTTON": {
          "ADD_FILE_OR_PICTURE": "Ajouter un fichier/image",
          "ADD_PICTURE": "Ajouter une image",
          "DELETE_PICTURE": "Supprimer"
        },
        "ERRORS": {
          "FILE_SIZE": "La taille de l’image ne doit pas excéder {fileSize}Mo.",
          "FILE_TYPE": "L’image doit être au format {fileTypes}."
        },
        "TOOLTIP": "<b>Taille recommandée :</b> {width} (largeur) par {height} pixels (hauteur) <br></br> <b>Formats acceptés :</b> .jpg, .jpeg, .png"
      },
      "PIN": "Ce contenu est mis à la une.",
      "TITLE": "Titre",
      "UNPIN": "Ce contenu n’est plus à la une."
    },
    "HOW_IT_WORKS": {
      "TITLE": "Comment ça marche ?"
    },
    "INDICATORS": {
      "ATTENDEES": "Participants",
      "COMMENTS": "Commentaires",
      "COMMUNICATIONS": "Actualités",
      "CONSULTATIONS": "Consultations",
      "IDEAS": "Contributions",
      "VOTES": "{online_count, plural, =0 {{online_count} vote en ligne} one {{online_count} vote en ligne} other {{online_count} votes en ligne}} - {offline_count, plural, =0 {{offline_count} vote hors-ligne} one {{offline_count} vote hors-ligne} other {{offline_count} votes hors-ligne}}"
    },
    "INTERACTIONS_BOX": {
      "CONTINUE_CONVERSATION": "Continuez la conversation",
      "GIVE_YOUR_OPINION": "Donnez votre avis"
    },
    "PREVIEW": "Voir sur le site",
    "PUBLIC_STUDY": "Enquête publique",
    "PUBLISHED": "Publié(e)",
    "PUBLISHED_AT": "Publié(e) le {date}",
    "PUBLISH_CANCELED": "La publication de ce contenu a été annulée",
    "PUBLISH_EDIT": "Modifier la planification",
    "PUBLISH_NOW": "Publier maintenant",
    "PUBLISH_NOW_TOASTER": "Votre contenu est désormais visible par les utilisateurs",
    "PUBLISH_SCHEDULED": "Planifier la publication",
    "REPORT": {
      "ACTION": "Signaler",
      "CODE_OF_ETHICS": "charte éthique",
      "CONFIRM": "Envoyer",
      "EMPTY_ERROR": "Vous devez remplir correctement les champs.",
      "FLUICITY_TERMS_PART_A": "En savoir plus sur les",
      "FLUICITY_TERMS_PART_B": "et la",
      "FLUICITY_TERMS_PART_C": "de Fluicity Engage.",
      "PLACEHOLDER": "Ajoutez un commentaire pour détailler votre signalement.",
      "SELECT_REASON": "Indiquez pourquoi vous signalez ce contenu :",
      "SUCCESS": "Merci pour ce signalement. Il nous permet d’assurer des contenus de qualité sur Fluicity Engage.",
      "TERMS_OF_USE": "Conditions Générales"
    },
    "RESPONSES_COUNT": "{count, plural, =0 {Réponse} one {Réponse} other {Réponses}}",
    "SAVE": "Enregistrer",
    "SAVE_THE_DRAFT": "Enregistrer le brouillon",
    "SCHEDULE": "Programmer",
    "SCHEDULED": "Planifié(e)",
    "SCHEDULED_AT": "Planifié(e) le {date}",
    "SCHEDULED_AT_TOASTER": "La publication de ce contenu est planifiée le {date}",
    "SEE": {
      "COLLABORATIVE_DECISION": "Voir la concertation",
      "FOLDER": "Voir le dossier",
      "IDEA": "Voir la contribution",
      "IDEAS_REQUEST": "Voir l’appel à contributions",
      "PARTICIPATORY_BUDGET": "Voir le budget participatif"
    },
    "SHOW": {
      "FROM_DATE_TO_DATE_WITH_TIME": "Du <strong>{startAtDate} à {startAtHour}</strong> au <strong>{endAtDate} à {endAtHour}</strong>",
      "QR_CODE": {
        "BLACK_AND_WHITE": "Noir et blanc",
        "DOWNLOAD": "Télécharger",
        "GENERATE": "Générer le QR code",
        "TITLE": "QR Code"
      },
      "SHARE_IT": "Partager"
    },
    "SORT": {
      "BUTTON": "Trier",
      "POPULAR": "Populaire",
      "RECENT": "Récent"
    },
    "STATS": {
      "TITLE_PARTICIPATION": "Synthèse de la participation"
    },
    "STATUS": {
      "FORM_TITLE": "{count, plural, =0 {Changer le statut} one {Changer le statut} other {Changer le statut : {count} contributions sélectionnées}}",
      "MODAL": {
        "TITLE": "Avancement d’une contribution"
      },
      "ORIGINAL_POST": {
        "LABEL": "Titre de la contribution originale qui sera conservée",
        "TITLE": "Renseigner le titre de la contribution originale à laquelle regrouper cette contribution :"
      },
      "POPOVER": {
        "BUTTON": "En savoir plus"
      },
      "SUBMIT": "Enregistrer",
      "TITLE": "Statut",
      "UPDATED_SUCCESSFULLY": "Le statut à été enregistré."
    },
    "STEPS": {
      "STATES": {
        "AVAILABLE": "Disponibles",
        "COMING": "À venir",
        "ENDED": "Terminée",
        "ENDLESS": "En continu",
        "ONGOING": "En cours"
      },
      "TABS": {
        "LABEL": "Onglets de sélection des phases de la publication"
      }
    },
    "SUMMARY": {
      "TITLE": "Résumé de la contribution",
      "TOOLTIP": "Ce résumé a été généré avec l’aide d’une intelligence artificielle afin de vous faciliter la lecture de la contribution."
    },
    "TAGS": {
      "PERIOD": "Du <strong>{startAtDate} à {startAtHour}</strong> au <strong>{endAtDate} à {endAtHour}</strong>",
      "PERIOD_SAME_DAY": "Le <strong>{startAtDate}</strong> de <strong>{startAtHour}</strong> à <strong>{endAtHour}</strong>",
      "PERIOD_SHORT": "Du <strong>{startAtDate}</strong> au <strong>{endAtDate}</strong>"
    },
    "TYPES": {
      "ANOMALY": "Anomalie",
      "ARTICLE": "Article",
      "COLLABORATIVE_DECISION": "Concertation",
      "DEMAND": "Message",
      "EVENT": "Événement",
      "FOLDER": "Dossier",
      "IDEA": "Contribution",
      "IDEAS_REQUEST": "Appel à contributions",
      "PARTICIPATORY_BUDGET": "Budget participatif",
      "STUDY": "Questionnaire",
      "SURVEY": "Questionnaire"
    },
    "UPDATED": "Le contenu a été mis à jour avec succès"
  },
  "POST_FORM": {
    "ACTION_SAVE": "Enregistrer",
    "ADMIN_UPDATE_ALERT": "Lorsque vous modifiez une contribution, nous envoyons automatiquement une notification par email à son auteur. Pour assurer que l’auteur soit en accord avec votre modification, nous vous conseillons de le contacter directement en amont.",
    "APPLICATION_FILE": "Importez votre fichier détaillé de candidature",
    "APPLICATION_FILE_BUTTON": "Ajouter un dossier",
    "APPLICATION_FILE_TOOLTIP": "Pour soumettre votre contribution, vous devez impérativement fournir un fichier détaillé de candidature. Pour cela, remplissez le modèle fourni et déposez-le ci-dessous.<br></br><br></br>Contrairement aux informations fournies dans le reste du formulaire (titre, description, thématique, etc.) qui seront publiques, le contenu du fichier ne sera accessible que par les administrateurs de la plateforme.<br></br><br></br><b>Formats acceptés :</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
    "ATTACHMENTS": {
      "DESCRIPTION": {
        "COMMUNICATION": "Partager des documents complémentaires tel que des images ou une vidéo à votre actualité.",
        "CONSULTATION": "Partager des documents complémentaires tel que votre règlement, des images ou une vidéo à votre consultation.",
        "FOLDER": "Partager des documents complémentaires tel que des images ou une vidéo à votre dossier."
      },
      "TITLE": "Pièces jointes"
    },
    "ATTACHMENTS_FILES": "Fichiers",
    "ATTACHMENTS_IMAGES": "Images",
    "ATTACHMENTS_TITLE": "Documents",
    "AUTHORED_BY": "Qui est l’auteur ?",
    "AUTHORED_BY_A_THIRD_PARTY": "Une personne tierce",
    "AUTHORED_BY_A_THIRD_PARTY_PLACEHOLDER": "Une personne hors plateforme",
    "AUTHORED_BY_CUSTOM": "Personnalisé",
    "AUTHORED_BY_CUSTOM_PLACEHOLDER": "Association, groupe de citoyens, assemblée…",
    "AUTHORED_BY_FIRST_NAME": "Prénom de l’auteur",
    "AUTHORED_BY_FIRST_NAME_PLACEHOLDER": "Exemple : Jean",
    "AUTHORED_BY_LAST_NAME": "Nom de l’auteur",
    "AUTHORED_BY_LAST_NAME_PLACEHOLDER": "Exemple : Dupont",
    "AUTHORED_BY_MYSELF": "Moi-même",
    "AUTHORED_BY_MY_SPACE": "Mon organisation",
    "BUDGET": "Budget estimé",
    "BUDGET_PLACEHOLDER": "Indiquez le budget",
    "CHOOSE_A_FOLDER": "Choisissez un dossier",
    "CONTENT": "Description",
    "CONTRIBUTION_KIND": {
      "CUSTOM_LABEL": "Type de contribution",
      "CUSTOM_PLACEHOLDER": "Indiquer le type de contributions que vous souhaitez récolter.",
      "DESCRIPTION": "Personnaliser le label du bouton (CTA) pour déposer des contributions.",
      "OPTIONS": {
        "CONTRIBUTION": "Contribution",
        "OTHER": "Autre",
        "PROPOSAL": "Proposition",
        "QUESTION": "Question",
        "REPORT": "Signalement"
      },
      "PREVIEW": "Aperçu :",
      "TITLE": "Type de contribution"
    },
    "DEFAULT_PROPOSAL_VIEW": {
      "OPTIONS": {
        "CAROUSEL": {
          "DESCRIPTION": "Pour favoriser les réactions (vote pour ou contre)",
          "NAME": "Carrousel"
        },
        "LIST": {
          "DESCRIPTION": "Pour un affichage compact de l’ensemble des contributions",
          "NAME": "Liste"
        },
        "MAP": {
          "DESCRIPTION": "Pour une visualisation géographique des contributions",
          "NAME": "Carte"
        }
      },
      "SUBTITLE": "Personnaliser la page de votre consultation en choisissant la vue par défaut des contributions. Dans tous les cas, les utilisateurs pourront choisir une vue différente.",
      "TITLE": "Affichage des contributions"
    },
    "DESCRIPTION": "Description",
    "DESCRIPTION_SECTION": {
      "DESCRIPTION": {
        "COMMUNICATION": "Cette section vous permet d’expliquer aux utilisateurs le contexte et les enjeux de votre actualité.",
        "CONSULTATION": "Cette section vous permet d’expliquer aux utilisateurs le contexte et les enjeux de votre consultation.",
        "FOLDER": "Cette section vous permet d’expliquer aux utilisateurs le contexte et les enjeux de votre dossier."
      },
      "TITLE": "Description de la démarche"
    },
    "DISPLAY_OPTIONS": {
      "CHILDREN_LIST_PICTURES": {
        "LABEL": "Afficher les images des contributions dans la liste",
        "TITLE": "Image"
      },
      "COMMENTS_ENABLED": {
        "LABEL": "Activer les commentaires sous votre enquête"
      },
      "GEOJSON": {
        "DESCRIPTION": "Personnaliser la carte avec des zones géographiques et points d’intérêt sur {link} puis coller le code ci-dessous.",
        "TITLE": "Personnaliser la carte"
      }
    },
    "EDIT": {
      "TITLE": {
        "ANOMALY": "Modifier l’anomalie",
        "COMMUNICATION": "Modifier l’actualité",
        "CONSULTATION": "Modifier la consultation",
        "DEMAND": "Modifier le message",
        "FOLDER": "Modifier le dossier",
        "IDEA": "Modifier la contribution"
      }
    },
    "EDITORS_FORM": {
      "DESCRIPTION": "Pour donner accès à un utilisateur, il doit être <i>Gestionnaire</i> de l’espace. Seul un <i>Administrateur</i> peut donner ce rôle.",
      "SUBTITLE": "La liste des utilisateurs qui ont accès à la gestion de cette consultation.",
      "TITLE": "Gestionnaires"
    },
    "END_AT": "Date et heure de fin",
    "ERRORS": {
      "FILL_FIELDS": "Vous devez remplir correctement les champs.",
      "LOCATION_NOT_IN_THE_LIST": "Vous devez sélectionner une adresse dans la liste."
    },
    "EVENT_URL_LABEL": "Visioconférence",
    "EVENT_URL_PLACEHOLDER": "Ajoutez l’URL d’une visioconférence Zoom, Jitsi, Teams, Meet, etc.",
    "FORM_BUILDER": {
      "ACCEPTED_ANSWERS": "Réponse(s) autorisée(s)",
      "ACCEPTED_ANSWERS_DATE_DESCRIPTION": "Valider la date renseignée par l’utilisateur avec une date de référence.",
      "ACCEPTED_ANSWERS_OPERATOR_LABEL": "Sélectionner un opérateur",
      "ACCEPTED_ANSWERS_QUESTION_OPTIONS_DESCRIPTION": "Sélectionner chaque réponse possible.",
      "ACCEPTED_ANSWERS_SUMMARY": "Réponses autorisées",
      "ACCEPTED_ANSWERS_TEXT_DESCRIPTION": "Séparer chaque réponse autorisée par un saut de ligne.",
      "ACCEPTED_ANSWERS_TEXT_PLACEHOLDER": "Réponse 1\nRéponse 2\nRéponse 3\nRéponse 4",
      "ADD_DESCRIPTION": "Ajouter une description",
      "ADD_QUESTION": "Ajouter une question",
      "ADD_SECTION": "Ajouter une section",
      "CONFIDENTIAL": "Confidentielle",
      "CONFIDENTIAL_INFORMATION_NOTICE": "Votre réponse sera visible uniquement par les administrateurs de la plateforme.",
      "CONFIDENTIAL_QUESTION": "Question confidentielle",
      "CONFIDENTIAL_QUESTION_DESCRIPTION": "La réponse sera visible uniquement par les administrateurs et les gestionnaires ayant les droits.",
      "DATE_OPERATOR": {
        "EQ": "est",
        "GT": "est supérieur à",
        "GTE": "est supérieur ou égal à",
        "LT": "est inférieur à",
        "LTE": "est inférieur ou égal à",
        "NOT_EQ": "n’est pas"
      },
      "DEFAULT_FIELD_INFO": "Par default",
      "DESCRIPTION_LABEL": "Description",
      "DESCRIPTION_PLACEHOLDER": "Exemple : Cette question nous permettra de mieux vous connaître.",
      "DROPDOWN_QUESTION": "Liste déroulante",
      "DROPDOWN_QUESTION_DESCRIPTION": "Les options seront affichées dans une liste déroulante",
      "MAXLENGTH": "Limiter le nombre de caractères",
      "MAXLENGTH_DESCRIPTION": "Renseigner le nombre maximum de caractères autorisés",
      "MAXLENGTH_LABEL": "Nombre de caractères",
      "MAXLENGTH_PLACEHOLDER": "Illimité",
      "MAXLENGTH_SUMMARY": "Caractères max.",
      "OPTIONS": {
        "ADD_OPTION": "Ajouter une option",
        "ADD_OTHER": "Ajouter « Autre »",
        "OR": "ou",
        "OTHER": "Autre"
      },
      "OPTION_LABEL": "Option {index}",
      "PLACEHOLDER": "Votre réponse",
      "QUESTION_LINKS": {
        "DESCRIPTION": "Afficher si la réponse à ...",
        "OPERATOR": {
          "BLANK": "est vide",
          "CONTAINS": "contient",
          "EQ": "est",
          "GT": "est supérieur à",
          "GTE": "est supérieur ou égal à",
          "LT": "est inférieur à",
          "LTE": "est inférieur ou égal à",
          "NOT_CONTAINS": "ne contient pas",
          "NOT_EQ": "n’est pas",
          "PRESENT": "n’est pas vide"
        },
        "OPERATOR_LABEL": "Opérateur",
        "OPTIONS_LABEL": "Options",
        "QUESTION_LABEL": "Question",
        "TITLE": "Affichage de la question"
      },
      "QUESTION_LINKS_SUMMARY": "Condition d’affichage",
      "REQUIRED": "Obligatoire",
      "REQUIRED_QUESTION": "Question obligatoire",
      "SUBMIT_FORM": "Soumettre le formulaire",
      "SURVEY_DESCRIPTION_1": "Le questionnaire correspond aux questions que vous souhaitez poser à vos utilisateurs.",
      "SURVEY_DESCRIPTION_2": "Configurer le questionnaire en fonction de votre consultation.",
      "SURVEY_TITLE": "Questionnaire",
      "TITLE_LABEL": "Question",
      "TITLE_PLACEHOLDER": "Exemple : Quel est votre âge ?",
      "TYPES": {
        "ATTACHMENT": "Pièces jointes",
        "CHECKBOX": "Réponses multiples",
        "DATE": "Date",
        "LOCATION": "Localisation",
        "MONEY": "Budget",
        "PHONE_NUMBER": "Numéro de téléphone",
        "PICTURE": "Image de couverture",
        "RADIO": "Réponse unique",
        "SECTION": "Section",
        "TEXT": "Réponse courte",
        "TEXTAREA": "Paragraphe",
        "TITLE": "Type de champ"
      },
      "TYPE_SELECT_WARNING": {
        "DESCRIPTION_1": "Vous avez déjà collecté des réponses pour cette question.",
        "DESCRIPTION_2": "Si vous la modifiez, les réponses associées seront définitivement effacées.",
        "DESCRIPTION_3": "Vous avez besoin de ces données ? Exportez vos réponses avant de supprimer cette question et/ou option.",
        "TITLE": "Êtes-vous sûr ?"
      }
    },
    "GENERAL_INFO": "Informations générales",
    "IMAGE": "Image",
    "LOCALISATION_LABEL": "Lieu ou adresse",
    "LOCALISATION_MARKER_PLACED": "Repère placé",
    "LOCALISATION_MODAL_NEGATIVE_BUTTON": "Effacer",
    "LOCALISATION_MODAL_NOTICE_TEXT": "Cliquez sur la carte pour positionner le repère.",
    "LOCALISATION_MODAL_POSITIVE_BUTTON": "Valider",
    "LOCALISATION_MODAL_TITLE": "Ajoutez une localisation",
    "LOCALISATION_NO_RESULTS": "Veuillez taper pour obtenir des suggestions",
    "LOCALISATION_PLACEHOLDER": "Ajoutez une localisation",
    "LOCALISATION_SEE_MAP": "Voir la carte",
    "MODERATABLE": {
      "LABEL": "Modération avant publication",
      "TOOLTIP": "Toutes les contributions devront être validées par un administrateur pour être publiées et visibles des autres utilisateurs."
    },
    "NEW": {
      "ANOMALIES": {
        "DESCRIPTION_PLACEHOLDER": "Formulez une description qui précise l’anomalie rencontrée et sa nature. Contextualisez-la afin de faciliter son traitement.",
        "MODAL_DESCRIPTION": "{spaceName} vous répondra dans les meilleurs délais.",
        "MODAL_TITLE": "Félicitations, l’anomalie est envoyée !",
        "SIDEBAR_ACTION": "Envoyer",
        "SIDEBAR_DESCRIPTION": "L’organisation est à votre écoute et vous répondra dans les meilleurs délais.",
        "TITLE": "Signaler une anomalie",
        "TITLE_PLACEHOLDER": "J’aimerais signaler…"
      },
      "ARTICLES": {
        "DESCRIPTION_PLACEHOLDER": "Présentez un sujet d’actualité ou valorisez une initiative, afin d’informer régulièrement sur les nouvelles mesures et diffuser des informations pédagogiques.",
        "MODAL_DESCRIPTION": "Il est désormais visible par les autres utilisateurs de cet espace. {isPrivateSpace, select, true {} other {Partagez-le sur les réseaux sociaux afin de lui donner encore plus de visibilité.}}",
        "MODAL_TITLE": "Félicitations, l’article est publié !",
        "PROBLEMATIC_PLACEHOLDER": "Décrivez en une phrase votre article pour donner envie de le lire",
        "TITLE": "Créer un article",
        "TITLE_PLACEHOLDER": "Rédigez un titre qui suscite l’intérêt des utilisateurs."
      },
      "COLLABORATIVE_DECISIONS": {
        "DESCRIPTION_PLACEHOLDER": "Donnez des détails sur le contexte de cette concertation. Expliquez les modalités de participation afin que les utilisateurs puissent participer de manière pertinente à la recherche de solutions.",
        "MODAL_DESCRIPTION": "Il est désormais visible par les autres utilisateurs. Epinglez-le sur votre page d’accueil en le mettant à la une pour encore plus de visibilité.",
        "MODAL_TITLE": "Félicitations, la concertation est publiée !",
        "PROBLEMATIC_PLACEHOLDER": "Donnez envie aux utilisateurs de participer en une phrase.",
        "SIDEBAR_ACTION": "Publier",
        "TITLE": "Créer une concertation",
        "TITLE_PLACEHOLDER": "Rédigez un titre qui suscite l’intérêt des utilisateurs."
      },
      "DEMANDS": {
        "DESCRIPTION_PLACEHOLDER": "Clarifiez le contexte du message en indiquant tout élément permettant de mieux comprendre votre sujet.",
        "MODAL_CTA": "Voir mes messages",
        "MODAL_DESCRIPTION": "Le destinataire va recevoir une notification dans les plus brefs délais. Vous pouvez à tout moment retrouver ce message dans le menu “Mes messages & anomalies” de votre profil.",
        "MODAL_TITLE": "Félicitations, le message est envoyé !",
        "SIDEBAR_ACTION": "Envoyer",
        "SIDEBAR_DESCRIPTION": "Ce contenu est confidentiel. Seul l’utilisateur et les administrateurs peuvent le visualiser.",
        "TITLE": "Envoyer un message",
        "TITLE_PLACEHOLDER": "J’aimerais obtenir des informations sur…"
      },
      "EVENTS": {
        "CONFIGURATION": {
          "DESCRIPTION": "Cette section vous permet de préciser aux utilisateurs la date et la localisation (adresse et / ou lien vers une visioconférence) de l’événement.",
          "TITLE": "Modalités de participation"
        },
        "DESCRIPTION_PLACEHOLDER": "Présentez le contexte de l’événement et informer les utilisateurs sur les conditions pour s’y rendre.",
        "MODAL_DESCRIPTION": "Il est désormais visible par les autres utilisateurs. Partagez-le sur les réseaux sociaux afin de lui donner encore plus de visibilité.",
        "MODAL_TITLE": "Félicitations, l’événement est publié !",
        "PROBLEMATIC_PLACEHOLDER": "Décrivez en une phrase votre événement pour donner envie de le lire",
        "SIDEBAR_ACTION": "Publier",
        "TITLE_PLACEHOLDER": "Rédigez un titre qui suscite l’intérêt des utilisateurs."
      },
      "FOLDERS": {
        "DESCRIPTION_PLACEHOLDER": "Donnez des détails sur le contexte de ce dossier. Expliquez les modalités de participation afin que les utilisateurs puissent participer de manière pertinente à la recherche de solutions.",
        "MODAL_DESCRIPTION": "Il est désormais visible par les autres utilisateurs. Epinglez-le sur votre page d’accueil en le mettant à la une pour encore plus de visibilité.",
        "MODAL_TITLE": "Félicitations, le dossier est publié !",
        "PROBLEMATIC_PLACEHOLDER": "Ajouter une phrase inspirante concernant votre dossier.",
        "SIDEBAR_ACTION": "Publier",
        "TITLE_PLACEHOLDER": "Rédigez un titre qui suscite l’intérêt des utilisateurs."
      },
      "IDEAS": {
        "DESCRIPTION_PLACEHOLDER": "Expliquez votre contribution et son fonctionnement.",
        "MODAL_CTA": "Voir mes contributions",
        "MODAL_DESCRIPTION": "Retrouvez toutes vos contributions dans votre profil.",
        "MODAL_DESCRIPTION_GUEST": "Pour suivre son évolution et recevoir des mises à jour, créez un compte. Sans inscription, vous ne pourrez plus voir son impact ni être notifié(e) des votes et commentaires.",
        "MODAL_TITLE": "Merci pour votre participation",
        "REDIRECT": "Ce lien ne semble pas fonctionner. Retrouvez la consultation dans la liste pour pouvoir y faire une contribution.",
        "TITLE": "Remplir le formulaire",
        "TITLE_PLACEHOLDER": "On pourrait…",
        "WITHOUT_MODERATION": {
          "SIDEBAR_ACTION": "Publier",
          "SIDEBAR_DESCRIPTION": "Une fois publiée, les autres utilisateurs pourront enrichir votre contribution en vous faisant des suggestions."
        },
        "WITH_MODERATION": {
          "SIDEBAR_ACTION": "Soumettre",
          "SIDEBAR_DESCRIPTION": "La contribution sera publiée une fois validée par les services."
        }
      },
      "IDEAS_REQUESTS": {
        "DESCRIPTION_PLACEHOLDER": "Donnez des détails sur le contexte de cet appel à contributions. Expliquez les modalités de participation afin que les utilisateurs puissent participer de manière pertinente à la recherche de solutions.",
        "MODAL_DESCRIPTION": "Il est désormais visible par les autres utilisateurs. Epinglez-le sur votre page d’accueil en le mettant à la une pour encore plus de visibilité.",
        "MODAL_TITLE": "Félicitations, l’appel à contributions est publié !",
        "PROBLEMATIC_PLACEHOLDER": "Donnez envie aux utilisateurs de participer en une phrase.",
        "SIDEBAR_ACTION": "Publier",
        "TITLE_PLACEHOLDER": "Rédigez un titre qui suscite l’intérêt des utilisateurs."
      },
      "PARTICIPATORY_BUDGETS": {
        "DESCRIPTION_PLACEHOLDER": "Donnez des détails sur le contexte de ce budget participatif. Expliquez les modalités de participation afin que les utilisateurs puissent participer de manière pertinente à la recherche de solutions.",
        "MODAL_DESCRIPTION": "Il est désormais visible par les autres utilisateurs. Epinglez-le sur votre page d’accueil en le mettant à la une pour encore plus de visibilité.",
        "MODAL_TITLE": "Félicitations, le budget participatif est publié !",
        "PROBLEMATIC_PLACEHOLDER": "Donnez envie aux utilisateurs de participer en une phrase.",
        "SIDEBAR_ACTION": "Publier",
        "TITLE_PLACEHOLDER": "Rédigez un titre qui suscite l’intérêt des utilisateurs."
      },
      "STUDIES": {
        "DESCRIPTION": "L’enquête correspond au formulaire créé en dehors de la plateforme sur Typeform, Google Form, Suvery Monkey, Tally ou toutes autres plateforme qui permettent de créer des formulaires.",
        "DESCRIPTION_PLACEHOLDER": "Donnez des détails sur le contexte de cette consultation ainsi que sur ses modalités de participation.",
        "FORM_DESCRIPTION": "Ajouter les liens de votre enquête pour la partager sur votre plateforme.",
        "MODAL_DESCRIPTION": "Elle est désormais visible par les autres utilisateurs. Partagez-la sur les réseaux sociaux afin de lui donner encore plus de visibilité.",
        "MODAL_TITLE": "Félicitations, l’enquête est publiée !",
        "PROBLEMATIC_PLACEHOLDER": "Donnez envie aux utilisateurs de participer en une phrase.",
        "SIDEBAR_ACTION": "Publier",
        "STUDY_ID_PLACEHOLDER": "Exemple : https://fluicity.typeform.com/to/A1b2C3d4",
        "STUDY_RESULT_PLACEHOLDER": "Exemple : https://fluicity.typeform.com/report/A1b2C3d4/E5f6G7h8",
        "STUDY_RESULT_TITLE": "Lien des résultats",
        "STUDY_TITLE": "Lien de l’enquête",
        "TITLE_PLACEHOLDER": "Rédigez un titre qui suscite l’intérêt des utilisateurs."
      },
      "TITLE": {
        "ANOMALY": "Créer une anomalie",
        "COMMUNICATION": "Créer une actualité",
        "CONSULTATION": "Créer une consultation",
        "DEMAND": "Créer un message",
        "FOLDER": "Créer un dossier",
        "IDEA": "Créer une contribution"
      }
    },
    "POST_PUBLISHED": "Ce contenu est à présent publié.",
    "POST_PUBLISHED_AT": "Publié le {date} à {time}",
    "POST_SAVED": "Les modifications ont été enregistrées.",
    "POST_SCHEDULED": "Ce contenu est planifié le {date} à {time}",
    "PROBLEMATIC": "Accroche",
    "PUBLICATION_CANCELLED": "La publication a bien été annulée.",
    "SIMILAR_PROPOSALS": "D’autres utilisateurs semblent avoir partagé des contributions similaires :",
    "START_AT": "Date et heure de début",
    "STEPS": {
      "CONFIGURATION": "Configuration de la phase",
      "DESCRIPTION": "Cette section vous permet de communiquer aux utilisateurs les dates clés de la consultation.",
      "DESCRIPTION_TABS": "Onglets de la description multilingue de la phase",
      "END_AT_HELPER_TEXT": "Optionnel pour les étapes en continu",
      "IMPLEMENTATION": {
        "ADMIN_ONLY_PLACEHOLDER": "Pensez à ajouter le \"Lien des résultats\" et vérifier la configuration pour activer l’option.",
        "ADMIN_ONLY_TEXT": "Afficher les résultats de la consultation",
        "SURVEYS": {
          "ADMIN_ONLY_PLACEHOLDER": "Le rapport complet présente l’ensemble des résultats de l’enquête, question par question. C’est un élément important de transparence vis à vis des utilisateurs.",
          "ADMIN_ONLY_TEXT": "Afficher les résultats de la consultation"
        }
      },
      "PLACEHOLDER": "Expliquez le déroulement de cette étape.",
      "SUBMISSION": {
        "ADMIN_ONLY_PLACEHOLDER": "Tous les utilisateurs peuvent publier des contributions dans la consultation. Si l’option est désactivée, seuls les administrateurs pourront créer de nouvelles contributions.",
        "ADMIN_ONLY_TEXT": "Dépôt ouvert aux utilisateurs"
      },
      "TITLE": "Configuration du déroulé"
    },
    "TITLE": "Titre",
    "UNDERSTOOD": "Compris !",
    "VIDEO": "Vidéo",
    "VIDEO_HELPER": "Vous pouvez uniquement partager une vidéo Youtube ou Vimeo.",
    "VIDEO_LABEL": "Lien vers une vidéo",
    "VIDEO_PLACEHOLDER": "Exemple : http://www.youtube.com/watch?=id ou http://vimeo.com/id",
    "VOTING_OPTIONS": {
      "BUDGET_RULE": {
        "LABEL": "Restreindre les votes (Pour) au budget de {count} précédemment défini",
        "TITLE": "Contrainte budgétaire"
      },
      "MIN_MAX": {
        "MAX_LABEL": "Nombre maximum de votes",
        "MIN_LABEL": "Nombre minimum de votes",
        "TITLE": "Nombre de soutiens alloués"
      },
      "TYPE": {
        "BUDGET": {
          "DESCRIPTION": "Les utilisateurs pourront soutenir les contributions jusqu’à épuisement de l’enveloppe totale. Les contributions devront être budgétisées.",
          "NAME": "Par enveloppe"
        },
        "DOUBLE": {
          "DESCRIPTION": "Les utilisateurs pourront soutenir les contributions de manière positive ou négative. Il est souvent utilisé dans le cas d’appel à contributions ou réactions.",
          "NAME": "Pour ou Contre"
        },
        "SINGLE": {
          "DESCRIPTION": "Les utilisateurs pourront soutenir les contributions de manière positive uniquement. Ce module est souvent utilisé si votre consultation prévoit une phase de vote.",
          "NAME": "Pour"
        },
        "SUBTITLE_1": "Les modalités de vote permettent aux utilisateurs de soutenir les contributions faites sur votre consultation.",
        "SUBTITLE_2": "Configurer les modalités en fonction de votre projet",
        "TITLE": "Modalités de vote"
      },
      "UNLIMITED": "Illimité"
    }
  },
  "POST_STEPS_TYPES": {
    "DEFAULT": {
      "ANALYSIS": "Analyse",
      "CONTRIBUTION": "Contribution",
      "IMPLEMENTATION": "Résultats",
      "SUBMISSION": "Dépôt",
      "VOTE": "Vote"
    },
    "STUDY": {
      "IMPLEMENTATION": "Résultats",
      "SUBMISSION": "Réponse"
    }
  },
  "PREVIOUS": "Précédent",
  "PROFILE": {
    "ADDRESS": "Commune",
    "BIRTHDATE": "Date de naissance",
    "CROSS_SPACES_WARNING": "Les informations ci-dessous concernent l’ensemble des espaces que vous avez rejoints.",
    "FIRST_NAME": "Prénom",
    "LAST_NAME": "Nom",
    "NAME_IS_PRIVATE": "Les autres utilisateurs vous verront en tant que : {displayName}",
    "NATIONAL_ID": "Numéro de registre national",
    "PRIVATE_INFORMATION_NOTICE": "Ces informations seront utilisées uniquement à des fins statistiques en lien avec la participation.",
    "PROFILE_UPDATED": "Profil mis à jour.",
    "SEX": "Sexe",
    "SEX_FEMALE": "Femme",
    "SEX_HELPER": "Tel qu’indiqué sur votre carte nationale d’identité. Cette donnée, une fois agrégée, est comparée aux statistiques fournies par des instituts nationaux ou par l’organisme lui-même.",
    "SEX_MALE": "Homme",
    "SEX_UNSPECIFIED": "Non spécifié",
    "SOCIOPROFESSIONAL_CATEGORY": "Catégorie socio-professionnelle",
    "TITLE": "Mon compte"
  },
  "PUBLISHING_POST_DIALOG": {
    "NO_QUESTIONS_WARNING": "Avant de pouvoir publier ce contenu, vous devez {link} au formulaire",
    "NO_QUESTIONS_WARNING_LINK_TEXT": "ajouter des questions",
    "PARENT_WARNING": "Avant de pouvoir publier ce contenu, vous devez publier {link}.",
    "PUBLISH": {
      "BUTTON": "Publier maintenant",
      "CONTENT": "Souhaitez-vous vraiment publier ?",
      "NO": "Non",
      "TOAST": "Ce contenu a été publié.",
      "YES": "Oui, publier"
    },
    "SCHEDULE": {
      "BUTTON": "Planifier la publication",
      "CONTENT": "Souhaitez-vous vraiment planifier ?",
      "NO": "Non",
      "TOAST": "Ce contenu a été planifié.",
      "YES": "Oui, planifier"
    },
    "UNPUBLISH": {
      "BUTTON": "Dépublier",
      "CHILDREN_WARNING": "En dépubliant ce contenu, tout ce qu’il contient sera également dépublié ({childrenCount}).",
      "CONTENT": "Souhaitez-vous vraiment dépublier ?",
      "NO": "Non",
      "TOAST": "Ce contenu a été dépublié.",
      "YES": "Oui, dépublier"
    },
    "UNSCHEDULE": {
      "BUTTON": "Annuler la planification",
      "CONTENT": "Souhaitez-vous vraiment annuler la planification ?",
      "NO": "Non",
      "TOAST": "La planification de ce contenu a été annulée.",
      "YES": "Oui, annuler la planification"
    }
  },
  "QUESTIONS": {
    "RESULTS": {
      "ANSWERS_COUNT": "{count, plural, =0 {Aucune réponse} one {{count} réponse} other {{count} réponses}}"
    }
  },
  "SEARCH": {
    "BUTTON": "Recherche",
    "CATEGORIES_PLACEHOLDER": "Filtrer par thématique",
    "EMPTY_SEARCH": {
      "NEW_SEARCH": "Commencez à taper des mots-clés dans la barre de recherche.",
      "NO_RESULTS": "Vérifiez que vous avez bien tout orthographié. Vous pouvez aussi essayer de raccourcir ou de reformuler votre recherche."
    },
    "INPUT_PLACEHOLDER": "Recherche",
    "RESULTS_COUNT": "{count, plural, =0 {Aucun résultat} one {{count} résultat} other {{count} résultats}}",
    "TYPES_PLACEHOLDER": "Filtrer par type de contenu"
  },
  "SECURED_STRATEGIES": {
    "BACK_TO_POST": "Retour à la consultation",
    "BIRTHDATE": {
      "TITLE": "Date de naissance"
    },
    "CSAM": {
      "TITLE": "Connexion via CSAM"
    },
    "CTA": "Participer",
    "DESCRIPTION": "<b>Cette consultation est sécurisée.</b> Pour y accéder, vous devez valider les données listées ci-dessous et renseigner celles qui manquent.<conditional> À tout moment, vous pouvez exercer vos droits d’accès, de rectification et d’effacement de ces données en contactant dpo@flui.city.</conditional>",
    "DIMENSIONS": {
      "ERROR": "Malheureusement, les informations que vous avez spécifiées ne vous permettent pas de participer à la consultation. Corrigez vos données ou retournez à la consultation.",
      "TITLE": "Dimensions"
    },
    "INLINE_DESCRIPTION": "<b>Cette consultation est sécurisée.</b> Pour y accéder, vous devez renseigner les données nécessaires. À tout moment, vous pouvez exercer vos droits d’accès, de rectification et d’effacement de ces données via la page de votre profil si vous possédez un compte ou par mail via dpo@flui.city.",
    "NATIONAL_ID": {
      "ERROR": "Vous devez rentrer un numéro de registre valide contenant 11 chiffres.",
      "TITLE": "Numéro de registre national"
    },
    "PENDING_VERIFICATION_TOOLTIP": "Votre participation sera prise en compte qu’<b>après vérification de vos documents</b>.",
    "PREVENT_GO_IDENTITY": {
      "BACK": "Verso (nouvelle carte d’identité uniquement)",
      "FORM": {
        "DESCRIPTION": "Veuillez fournir le recto et le verso de votre pièce d’identité (format JPEG, JPG, PNG, HEIC, WEBP ou PDF, taille maximale recommandée 2MB).<br></br>Sont acceptés uniquement :<ul><li>Carte nationale d’identité</li><li>Passeport français</li><li>Permis de conduire (nouveau format carte de crédit)</li></ul>",
        "GENERIC_ERROR": "Une erreur est survenue pendant le téléchargement de vos documents. Veuillez vérifier l’état de votre connexion ou réessayez plus tard. Vous pouvez également essayer en réduisant la taille du document (taille maximale recommandée 2MB).",
        "SUCCESS_TOAST": "Votre identité a été vérifiée avec succès."
      },
      "FRONT": "Recto",
      "NO": "Non",
      "TITLE": "Pièce d’identité",
      "YES": "Oui"
    },
    "PROOF_OF_RESIDENCY": {
      "ACCEPTED_DOCUMENTS": "Sont acceptés uniquement : <ul><li>Facture d’électricité, de gaz ou d’eau récente</li><li>Facture de téléphone fixe ou mobile</li><li>Bulletin de salaire</li><li>Attestation d��assurance logement (incendie, risques locatifs ou responsabilité civile)</li><li>Carte électorale</li><li>Avis d’imposition</li></ul>",
      "BUTTON_DISABLED_TOOLTIP": "Vous devez d’abord valider votre pièce d’identité pour envoyer votre justificatif de domicile.",
      "DESCRIPTION": "Veuillez fournir un justificatif de domicile (format JPEG, JPG, PNG, HEIC, WEBP ou PDF, taille maximale recommandée 2MB).",
      "DOCUMENT_CONFIRMATION": "Après vérification par nos équipes, un email vous sera envoyé pour confirmer votre participation",
      "TITLE": "Justificatif de domicile"
    },
    "QUESTIONS": {
      "INCORRECT_VALUE": "Cette valeur est incorrecte."
    },
    "SIGNUP_INVITATION": "Si vous souhaitez <b>recevoir un e-mail de confirmation</b> de votre participation et enregistrer vos documents, veuillez vous créer un compte.",
    "SUCCESS": "Vous pouvez maintenant participer à la consultation.",
    "TOOLTIP": "Cette consultation est sécurisée et requiert certaines informations pour y participer.",
    "VALIDATED_INLINE_DESCRIPTION": "Nous avons validé votre identité en tant que <b>{fullName}</b>.",
    "VERIFIED_EMAIL": {
      "TITLE": "Vérification de compte"
    }
  },
  "SECURITY": {
    "DISPLAY_SECURED_STRATEGY_QUESTIONS": "Afficher les questions de sécurité",
    "FORM_BUILDER": {
      "DESCRIPTION": "Les questions de sécurité sont des mécanismes de contrôle d’accès.<br></br> Elles permettent de vérifier que les participants remplissent certaines conditions avant de contribuer, voter, commenter ou répondre à une enquête (par exemple : code d’accès, ID national, résident d’un territoire, etc.).",
      "TITLE": "Questions de sécurité"
    },
    "OPTION_1": {
      "DESCRIPTION": "Aucune inscription n’est requise pour participer",
      "TITLE": "Tout le monde"
    },
    "OPTION_2": {
      "DESCRIPTION": "Les utilisateurs doivent s’inscrire pour participer",
      "TITLE": "Inscrits"
    },
    "OPTION_3": {
      "DESCRIPTION": "Les utilisateurs doivent vérifier leur compte pour participer.",
      "TITLE": "Utilisateurs vérifiés"
    },
    "OPTION_4": {
      "DESCRIPTION": "Le dépôt est fermé aux utilisateurs",
      "TITLE": "Administrateurs"
    },
    "WHO_CAN_COMMENT": "Qui peut commenter ?",
    "WHO_CAN_RESPOND_SURVEY": "Qui peut répondre à l’enquête ?",
    "WHO_CAN_SUBMIT_CONTRIBUTION": "Qui peut déposer une contribution ?",
    "WHO_CAN_VOTE": "Qui peut voter ?"
  },
  "SETTINGS": {
    "ACCOUNT": {
      "CONNECTION_SETTINGS": "Paramètres de connexion",
      "DATA_SHARED_WITH_SPACE": "Mes données",
      "LANGUAGE": "Langue",
      "PASSWORD": "Mot de passe (12 caractères minimum)",
      "VERIFIED": "Vérifié",
      "VERIFIED_EMAIL": "E-mail vérifié"
    },
    "COOKIES": {
      "DESCRIPTION": "Les cookies “fonctionnels” suivants permettent d’activer des fonctionnalités spécifiques et optionnelles sur Fluicity Engage afin d’améliorer votre expérience utilisateur.",
      "FACEBOOK": {
        "DESCRIPTION": "Vous permet de vous connecter à votre espace de participation à l’aide de votre compte Facebook.",
        "TITLE": "Facebook Connect"
      },
      "GOOGLE": {
        "DESCRIPTION": "Vous permet de vous connecter à votre espace de participation à l’aide de votre compte Google.",
        "TITLE": "Google Sign-in"
      },
      "TITLE": "Mes préférences relatives aux cookies",
      "VIMEO": {
        "DESCRIPTION": "Vous permet de visualiser les vidéos hébergées sur Vimeo directement depuis votre espace de participation.",
        "TITLE": "Vimeo"
      },
      "YOUTUBE": {
        "DESCRIPTION": "Vous permet de visualiser les vidéos hébergées sur Youtube directement depuis votre espace de participation.",
        "TITLE": "Youtube"
      }
    },
    "DESTROY_ACCOUNT": {
      "CONFIRM": "Oui, supprimer mon compte",
      "CTA": "Supprimer mon compte",
      "TITLE": "Êtes-vous certain de vouloir supprimer votre compte Fluicity Engage ?"
    },
    "EMAIL_SUBSCRIPTION": {
      "UNSUBSCRIBE": {
        "SUCCESS_DESCRIPTION": "Pour vous désabonner ou vous ré-abonner à un ou plusieurs types de notifications, vous pouvez modifier vos paramètres ci-dessous. Ces réglages sont en outre accessibles à tout moment depuis les paramètres de votre compte.",
        "SUCCESS_TITLE": "Votre demande de désabonnement a bien été prise en compte."
      }
    },
    "JOIN_SPACE": "Rejoindre {spaceName}",
    "LANGUAGE": {
      "LABEL": "Langue"
    },
    "LEAVE_SPACE": {
      "CONFIRM": "Oui, quitter l’espace",
      "CTA": "Quitter {spaceName}",
      "DESCRIPTION": "En quittant cet espace, vous ne recevrez plus les notifications liées aux consultations ou actualités et ne pourrez plus faire de nouvelles contributions, commenter, voter, etc.",
      "TITLE": "Êtes-vous certain de vouloir quitter {spaceName} ?"
    },
    "NO_SPACES": "Vous ne suivez aucun espace.",
    "PASSWORD": {
      "CONFIRMATION": "Confirmation mot de passe",
      "CREATE": "Créer",
      "CREATE_INPUT": "Créer un mot de passe",
      "CREATE_MESSAGE": "Vous n’avez pas encore configuré de mot de passe",
      "CURRENT": "Mot de passe actuel",
      "DIALOG": {
        "CREATE_TITLE": "Créer un mot de passe",
        "SUBTITLE_2": "Merci de saisir votre mot de passe actuel et votre nouveau mot de passe :",
        "TITLE": "Modifier mon mot de passe",
        "VALIDATE": "Valider"
      },
      "ERROR_LOGIN": "Erreur de connexion.",
      "FORGOT_PASSWORD": "Mot de passe oublié ?",
      "NEW": "Nouveau mot de passe",
      "PLACEHOLDER": "Mot de passe",
      "SHORT_PASSWORD": "la taille du mot de passe ne peut pas être inférieure à {length} caractères",
      "SUCCESS": "Le nouveau mot de passe a été enregistré.",
      "UPDATE": "Modifier",
      "WRONG_PASSWORD": "Le mot de passe doit faire 8 caractères minimum."
    },
    "PERSONAL_DATA": {
      "REQUEST_PERSONAL_DATA": {
        "BUTTON": "Faire une demande de portabilité de mes données personnelles",
        "EMAIL_BODY": "Bonjour,\n\nConformément à la Politique de confidentialité des données de la solution Fluicity Engage, je souhaite obtenir un export de l’ensemble des données personnelles me concernant hébergées sur la plateforme.\n\nMon identifiant mail sur la plateforme est : {userEmail}\n\nPar avance merci,\n\n{userName}",
        "EMAIL_SUBJECT": "Demande de portabilité de mes données"
      },
      "TITLE": "Vie privée et données personnelles"
    },
    "REQUIRED_DIMENSION_INFO": "Certaines informations sont requises pour la participation à cet espace. Pour exercer vos droits à l’effacement, il vous suffit de quitter l’espace.",
    "SPACE_SELECTION": "Choix de l’espace",
    "TABS": {
      "INFO": "Mes informations",
      "MY_SPACE": "Mon espace",
      "NOTIFICATIONS": "Mes notifications",
      "SETTINGS": "Mes paramètres"
    }
  },
  "SIGN_IN": "Rejoindre",
  "SIGN_OUT": "Déconnexion",
  "SIGN_UP": {
    "EMAIL": "E-mail",
    "LOCATION_LABEL": "Commune de résidence",
    "LOCATION_PLACEHOLDER": "Exemple : Paris",
    "PRIVACY": "Politique de Confidentialité",
    "TERMS": "Conditions d’utilisation"
  },
  "SORT": {
    "COMMENTED": "Les plus commentées",
    "LEAST_EXPENSIVE": "Les moins coûteuses",
    "POPULAR": "Populaire",
    "RANDOM": "Aléatoire",
    "RECENT": "Les plus récentes",
    "UPVOTED": "Les plus votées"
  },
  "SPACE": {
    "ABOUT": {
      "STATS": {
        "CONSULTATIONS_COUNT": "{count, plural, =0 {consultation lancée} one {consultation lancée} other {consultations lancées}}",
        "IDEAS_DONE_COUNT": "{count, plural, =0 {contribution concrétisée} one {contribution concrétisée} other {contributions concrétisées}}",
        "PARTICIPATIONS_COUNT": "{count, plural, =0 {participation} one {participation} other {participations}}",
        "SUBSCRIBED_CITIZENS": "{count, plural, =0 {inscrit} one {inscrit} other {inscrits}}"
      },
      "TITLE": "Général"
    },
    "CONSULTATIONS": {
      "EMPTY_STATE": "Vous retrouverez ici les dossiers, appels à contributions, budgets participatifs et enquêtes publiés par l’organisation.",
      "TITLE": "{count, plural, =0 {Aucune consultation} one {{count} consultation} other {{count} consultations}}"
    },
    "CONTRIBUTIONS": {
      "MESSAGING": {
        "EMPTY_STATE": "Vous retrouverez ici vos messages et anomalies.",
        "TITLE": "Mes messages & anomalies"
      },
      "PROPOSALS": {
        "EMPTY_STATE": "Vous retrouverez ici vos contributions.",
        "TITLE": "Mes contributions"
      }
    },
    "FORM": {
      "ADDRESS_LABEL": "Adresse",
      "ADDRESS_PLACEHOLDER": "Recherchez une adresse",
      "ADMINISTRATORS": "Administrateurs",
      "BRAND_LOGO_LABEL": "Logo de votre espace",
      "BRAND_LOGO_TOOLTIP": "Le logo de l’espace sera affiché en haut à gauche de la page dans la barre de navigation, et dans les emails.",
      "COLOR_LABEL": "Couleur",
      "COLOR_PLACEHOLDER": "Couleur",
      "DECISION_MAKER_FIRST_NAME_LABEL": "Prénom du sponsor",
      "DECISION_MAKER_FIRST_NAME_PLACEHOLDER": "Entrez le prénom",
      "DECISION_MAKER_LAST_NAME_LABEL": "Nom du sponsor",
      "DECISION_MAKER_LAST_NAME_PLACEHOLDER": "Entrez le nom",
      "DECISION_MAKER_PICTURE_LABEL": "Image de profil du sponsor",
      "DECISION_MAKER_ROLE_LABEL": "Rôle du sponsor",
      "DECISION_MAKER_ROLE_PLACEHOLDER": "Précisez la mission du sponsor dans votre organisation",
      "DESCRIPTION_HELPER": "La balise meta description permet aux moteurs de recherche d’avoir un aperçu du contenu des pages affichées lors d’une recherche.",
      "DESCRIPTION_LABEL": "Meta description",
      "DESCRIPTION_PLACEHOLDER": "Rédigez un texte d’accroche court et engageant",
      "EMAIL_LABEL": "E-mail",
      "EMAIL_PLACEHOLDER": "email@monsite.com",
      "FACEBOOK_URL_LABEL": "Facebook",
      "FACEBOOK_URL_PLACEHOLDER": "https://www.facebook.com/mapage",
      "FAVICON_LABEL": "Favicon",
      "FAVICON_TOOLTIP": "Le favicon est l’icône qui apparaît dans les onglets du navigateur pour identifier plus simplement votre site.",
      "INSTAGRAM_URL_LABEL": "Instagram",
      "INSTAGRAM_URL_PLACEHOLDER": "https://www.instagram.com/mapage",
      "LEGAL_NOTICE": {
        "COMPANY_ADDRESS": "Adresse : 210 avenue Jean Jaurès, 69007 Lyon, France",
        "COMPANY_EMAIL": "Email : info@flui.city",
        "COMPANY_NAME": "Fluicity",
        "COMPANY_PHONE": "Téléphone : +33 4 72 51 77 55",
        "HOSTED_BY_AWS": "Site hébergé par : Amazon Web Services (AWS) à Paris, France",
        "HOSTING": "Hébergement",
        "HOSTING_AND_TECHNICAL_SOLUTION": "Hébergement et solution technique",
        "HOST_ADDRESS": "Adresse de l’hébergeur : 38 avenue John F. Kennedy, L-1855 Luxembourg",
        "PLATFORM_HOSTED_BY": "La plateforme est hébergée et propulsée par Fluicity Engage, une solution éditée par la société Fluicity.",
        "THIRD_PARTY_TRUST": "Fluicity Engage agit en tant que tiers de confiance pour la collecte et le traitement des données, dans le respect du RGPD."
      },
      "LINKEDIN_URL_LABEL": "LinkedIn",
      "LINKEDIN_URL_PLACEHOLDER": "https://www.linkedin.com/mapage",
      "LOCALES": "Langues",
      "LOCALES_HELPER": "Sélectionner les langues dans lesquelles les utilisateurs pourront naviguer sur votre plateforme.",
      "LOCALES_LABEL": "Langues disponibles",
      "LOCALE_DEFAULT_HELPER": "Sélectionner la langue par défaut de votre plateforme.",
      "LOCALE_DEFAULT_LABEL": "Langue par défaut",
      "LOGO_PICTURE_LABEL": "Image de profil des administrateurs",
      "LOGO_PICTURE_TOOLTIP": "Lorsqu’ils créent une consultation, une contribution, un message ou commentent sur la plateforme, les administrateurs seront identifiés par cette image de profil et le nom de l’espace en remplacement de leur propre image et nom.",
      "NAME_HELPER": "Le nom de l’espace sera affiché à de nombreux endroits : dans le nom des pages, dans les emails, à la place du nom des admins, etc.",
      "NAME_LABEL": "Nom de l’espace",
      "NAME_PLACEHOLDER": "Définissez le nom de votre espace",
      "PHONE_LABEL": "Téléphone",
      "PHONE_PLACEHOLDER": "0123456789",
      "PRIMARY_COLOR_LABEL": "Couleur principale",
      "PRIMARY_COLOR_PLACEHOLDER": "Couleur principale",
      "SECONDARY_COLOR_LABEL": "Couleur secondaire",
      "SECONDARY_COLOR_PLACEHOLDER": "Couleur secondaire",
      "SPACE_DECISION_MAKER": "Sponsor",
      "SPACE_DECISION_MAKER_TOOLTIP": "Le sponsor est une personnalité de votre organisation qui va motiver, rassurer, engager vos utilisateurs.",
      "SPACE_LEGAL_NOTICE": "Mentions légales",
      "SPACE_LEGAL_NOTICE_LABEL": "Description",
      "SPACE_LEGAL_NOTICE_PLACEHOLDER": "Cette page s’affiche en bas de votre plateforme, sous le pied de page, avec des informations pré-remplies par Fluicity Engage en tant qu’hébergeur et éditeur technique de la solution.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_1": "Les mentions légales permettent d’informer les utilisateurs sur l’identité du responsable du site, l’hébergeur, et les conditions d’édition de la plateforme.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_2": "Elles sont obligatoires pour tout site institutionnel ou public, et renforcent la transparence de votre démarche.",
      "SPACE_PRIVACY_POLICY": "Politique de confidentialité",
      "SPACE_PRIVACY_POLICY_LABEL": "Description",
      "SPACE_PRIVACY_POLICY_PLACEHOLDER": "Cette page s’affiche en bas de votre plateforme, sous le pied de page, avec des informations Fluicity Engage.",
      "SPACE_PRIVACY_POLICY_TOOLTIP_1": "La politique de confidentialité permet d’informer les participants sur le traitement de leurs données personnelles. Vous pouvez ajouter ici des précisions propres à votre organisation (ex. : durée de conservation spécifique, contact DPO, usage interne des données,…).",
      "SPACE_PRIVACY_POLICY_TOOLTIP_2": "Ce texte complète la <link>politique de confidentialité d’Fluicity Engage</link>, responsable technique de la plateforme, et garant de la conformité RGPD. L'ajout de votre propre texte reste facultatif en fonction de votre usage de la plateforme.",
      "SPACE_TERMS_OF_USE": "Conditions d’utilisation",
      "SPACE_TERMS_OF_USE_LABEL": "Description",
      "SPACE_TERMS_OF_USE_PLACEHOLDER": "Cette page s’affiche en bas de votre plateforme, sous le pied de page, avec des informations Fluicity Engage.",
      "SPACE_TERMS_OF_USE_TOOLTIP_1": "Les conditions d’utilisation définissent les règles de bon usage de votre espace, les droits et responsabilités des utilisateurs, ainsi que vos engagements en tant qu’organisateur de la démarche. (ex: règles de modération, droits de participation, etc).",
      "SPACE_TERMS_OF_USE_TOOLTIP_2": "Ce texte complète les <link>CGU d’Fluicity Engage</link>, en tant que tiers de confiance et éditeur de la plateforme. L'ajout de votre propre texte reste facultatif en fonction de votre usage de la plateforme.",
      "TOPICS": "Thématiques",
      "TOPICS_DESCRIPTION": "Les thématiques permettent de catégoriser vos contenus pour aider les utilisateurs à trouver les contenus par leur centre d’intéret.",
      "TWITTER_URL_LABEL": "Twitter",
      "TWITTER_URL_PLACEHOLDER": "https://twitter.com/mapage",
      "UPDATED_SUCCESSFULLY": "Votre espace a été mis à jour avec succès.",
      "USERS_NOTIFICATIONS_SETTINGS": {
        "EVENTABLE": {
          "LABEL": "Envoyer une notification automatiquement lors du lancement d’une consultation et pour toutes ses phases de participation."
        },
        "TITLE": "Notifications",
        "WEEKLY": {
          "LABEL": "Envoyer un récapitulatif des actualités de la semaine aux inscrits (nouveaux articles, nouveaux événements et relances pour participer à une consultation)."
        }
      },
      "WEBSITE_URL_LABEL": "Site internet",
      "WEBSITE_URL_PLACEHOLDER": "https://www.monsite.com",
      "YOUR_SPACE": "Votre espace"
    },
    "HOME": {
      "AFFILIATES": {
        "AFFILIATED": "Espaces liés",
        "SEE_MORE": "Voir plus ({count})"
      },
      "FOOTER": {
        "TITLE": "Restons en contact !"
      },
      "SEE": "Voir",
      "SPACE_INFO": {
        "CITIZENS_COUNT": "{count, plural, =0 {Aucun inscrit} one {{count} inscrit} other {{count} inscrits}}",
        "IDEAS_COUNT": "{count, plural, =0 {Aucune participation} one {{count} participation} other {{count} participations}}"
      },
      "SPONSOR": "Cet espace est associé avec"
    },
    "NEWS": {
      "EMPTY_STATE": "Vous retrouverez ici les articles et événements publiés par l’organisation.",
      "TITLE": "{count, plural, =0 {Aucune actualité} one {{count} actualité} other {{count} actualités}}"
    },
    "PRIVACY_POLICY": {
      "ACCESS_FLUICITY_PRIVACY": "Consulter la politique de confidentialité de Fluicity Engage"
    },
    "SETTINGS": {
      "ACCESS": {
        "TAB_DATA_COLLECTION": "Formulaire d’inscription",
        "TAB_INVITATIONS": "Invitations"
      },
      "COMMUNICATION": {
        "TAB_NOTIFICATIONS": "Notifications"
      },
      "GENERAL": {
        "TAB_APPEARANCE": "Apparence",
        "TAB_LANGUAGES": "Langues",
        "TAB_TOPICS": "Thématiques"
      },
      "LEGAL": {
        "TAB_LEGAL_NOTICE": "Mentions légales",
        "TAB_PRIVACY_POLICY": "Politique de confidentialité",
        "TAB_TERMS_OF_USE": "Conditions d’utilisation"
      },
      "PAGES": {
        "TAB_ABOUT": "À propos",
        "TAB_FOOTER": "Pied de page",
        "TAB_HOME": "Accueil",
        "TAB_NAVIGATION": "Barre de navigation"
      }
    },
    "TERMS_OF_USE": {
      "ACCESS_FLUICITY_TERMS": "Consulter les conditions d’utilisation de Fluicity Engage"
    }
  },
  "SPACE_DATA_COLLECTION": {
    "GENERAL_INFO": "Informations générales",
    "PROF_CATEGORY_ID": {
      "LABEL": "Catégorie socio-professionnelle"
    },
    "SECTION": {
      "HEADER": "Formulaire d’inscription",
      "SUBTITLE1": "Le formulaire d’inscription est un outil qui permet de collecter des données sur les utilisateurs.",
      "SUBTITLE2": "Configurez les champs de collecte selon vos besoins en veillant à respecter le RGPD."
    }
  },
  "STATS": {
    "AGE": {
      "BETWEEN_15_AND_29": "15-29",
      "BETWEEN_30_AND_44": "30-44",
      "BETWEEN_45_AND_59": "45-59",
      "BETWEEN_60_AND_74": "60-74",
      "GT_75": ">75",
      "LT_15": "<15",
      "TITLE": "Âge"
    },
    "AI": {
      "ACTIONS": "Aspirations des utilisateurs :",
      "ACTIONS_TOOLTIP": "Ce résumé des aspirations des utilisateurs est généré par l’IA. Il a pour objectif de vous aider à interpréter les contributions originales déposées par les participants. Il se base sur les contributions regroupées ci-dessous.",
      "ADD_CLUSTER": "Ajouter un groupe thématique",
      "ADD_SUB_CLUSTER": "Ajouter un sous-groupe",
      "CLUSTER": {
        "SUMMARY": "Description du groupe thématique",
        "SUMMARY_PLACEHOLDER": "La description du groupe thématique",
        "TITLE": "Nom du groupe thématique",
        "TITLE_PLACEHOLDER": "Le nom du groupe thématique sera utilisé par l’IA pour regrouper les contributions."
      },
      "DELETE": "Supprimer",
      "DESCRIPTION": "Description :",
      "EDIT": "Modifier",
      "EDIT_CLUSTER": "Modifier le thème",
      "EDIT_SUB_CLUSTER": "Modifier le sous-groupe",
      "EXPLAIN_AI": "Nous avons recours à l’intelligence artificielle pour examiner attentivement les contributions de cette consultation. Notre objectif est de les regrouper en différentes catégories en fonction de leur similitude, afin de vous offrir une meilleure compréhension des tendances, des aspirations principales et des contributions émergentes. Grâce à cette approche, vous pourrez mieux saisir les contrubitions qui émergent et les opinions qui se dégagent au sein de cette consultation.",
      "GENERATE": "Lancer l’analyse",
      "IDEAS": "Contributions originales :",
      "IN_FAVOR": "Pour",
      "MOVE_IDEA": "Déplacer",
      "MOVE_IDEA_TITLE": "Changer de groupe thématique ou de sous-groupe",
      "OPPOSED": "Contre",
      "SUB_CLUSTER": {
        "SUMMARY": "Description du sous-groupe",
        "SUMMARY_PLACEHOLDER": "La description du sous-groupe",
        "TITLE": "Nom du sous-groupe",
        "TITLE_PLACEHOLDER": "Le nom du sous-groupe thématique sera utilisé par l’IA pour regrouper les contributions."
      },
      "TOAST": "L’analyse IA est en cours. Cela peut prendre quelques minutes."
    },
    "CITIES": {
      "TITLE": "Lieu de résidence"
    },
    "CLUSTERS": "Groupes thématiques",
    "CLUSTERS_TOOLTIP": "Les différentes aspirations des utilisateurs sont regroupées par l’IA au sein d’une ou plusieurs thématiques",
    "CLUSTER_OTHER": "Autre",
    "COUNTER_WITH_TREND": {
      "TOOLTIP": "Depuis les 7 derniers jours"
    },
    "COUNT_PROPOSALS": "{count} {count, plural, =0 {contribution} one {contribution} other {contributions}}",
    "DAY": "Jour",
    "DELIVERABILITY": "Délivrabilité",
    "IDEAS_STATUSES": {
      "TITLE": "Statut des contributions"
    },
    "KPIS": {
      "TOTAL_COMMENTS": "{count, plural, =0 {Commentaire} one {Commentaire} other {Commentaires}}",
      "TOTAL_FORM_RESPONSES": "{count, plural, =0 {Réponse} one {Réponse} other {Réponses}}",
      "TOTAL_PARTICIPANTS": "{count, plural, =0 {Participant} one {Participant} other {Participants}}",
      "TOTAL_VOTES_AGAINST": "{count, plural, =0 {Vote contre} one {Vote contre} other {Votes contre}}",
      "TOTAL_VOTES_FOR": "{count, plural, =0 {Vote pour} one {Vote pour} other {Votes pour}}"
    },
    "MONTH": "Mois",
    "NO_DATA": "Il n’y a pas encore de données disponibles pour le moment.",
    "PARTICIPANTS": {
      "TITLE": "Nombre de participants",
      "TOTAL_PARTICIPANTS": "Participants",
      "TOTAL_TARGETED_USERS": "Utilisateurs inscrits"
    },
    "PARTICIPANTS_PROGRESSION": "Évolution des participants",
    "PARTICIPANTS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Actions réalisées par les participants",
      "TOTAL_COMMENTS": "Commente",
      "TOTAL_IDEAS": "Fait une contribution",
      "TOTAL_NO_ACTIONS": "Aucune action",
      "TOTAL_STUDY_ANSWERS": "Réponses enquête",
      "TOTAL_VOTES": "Vote"
    },
    "PARTICIPATION_PROGRESSION": "Évolution de la participation",
    "PERFORMANCE": "Performance",
    "PROF_CATEGORIES": {
      "TITLE": "Catégorie socio-professionnelle"
    },
    "REFERRERS": "Sources de trafic",
    "SECTIONS": {
      "ACTIVITY": "Activité",
      "ENGAGEMENT": "Engagement",
      "PARTICIPANTS_PROFILE": "Profil des participants"
    },
    "SEX": {
      "TITLE": "Sexe",
      "TOTAL_": "Non spécifié",
      "TOTAL_FEMALE": "Femme",
      "TOTAL_MALE": "Homme",
      "TOTAL_UNSPECIFIED": "Non spécifié"
    },
    "SUBSCRIPTIONS": {
      "TITLE": "Objectifs d’inscriptions",
      "TOTAL_TARGETED_USERS": "Objectif",
      "TOTAL_USERS": "Utilisateurs inscrits"
    },
    "SUBSCRIPTION_PROGRESSION": {
      "TITLE": "Évolution des inscriptions"
    },
    "TAB_AI": "Analyse IA (bêta)",
    "TAB_ATTENDEES": "Participants",
    "TAB_CONTENTS": "Contenus",
    "TAB_DETAILS": "Détails",
    "TAB_EMAILS": "E-mail avec l’auteur",
    "TAB_LIST": "Liste",
    "TAB_PARTICIPATION": "Participation",
    "TAB_PRIVATE_NOTES": "Notes internes",
    "TAB_PROPOSALS": "Contributions",
    "TAB_RESPONSES": "Réponses",
    "TAB_RESULTS": "Résultats",
    "TAB_SETTINGS": "Paramètres",
    "TAB_STATS": "Statistiques",
    "TAB_VOTES": "Votes",
    "TARGETED_POPULATION": "Démographie (source officielle)",
    "TOP_CONSULTATIONS": {
      "COL_TITLE": "Titre",
      "COL_TOTAL": "Participants",
      "SUBTITLE": "Total des contributions, commentaires, votes ou réponses à l’enquête",
      "TITLE": "Consultations populaires"
    },
    "TOP_VIEWED_POSTS": {
      "COL_TITLE": "Titre",
      "COL_TOTAL": "Visiteurs",
      "COL_TYPE": "Type",
      "TITLE": "Contenus les plus visités"
    },
    "TOTAL_ANSWERS": "{answersCount} sur {totalCount} {totalCount, plural, =0 {répondant} one {répondant} other {répondants}}",
    "TOTAL_BOUNCED": "Rebondi",
    "TOTAL_CLICKED": "Cliqué",
    "TOTAL_COMMENTS": "Commentaires",
    "TOTAL_COMMUNICATIONS": "Actualités",
    "TOTAL_CONSULTATIONS": "Consultations",
    "TOTAL_DELIVERED": "Délivré",
    "TOTAL_IDEAS": "Contributions",
    "TOTAL_OFFLINE_VOTES": "Votes hors ligne",
    "TOTAL_ONLINE_VOTES": "Votes en ligne",
    "TOTAL_OPENED": "Ouvert",
    "TOTAL_PARTICIPANTS": "Participants",
    "TOTAL_REJECTED": "Rejeté",
    "TOTAL_RESPONDENTS": "Répondants",
    "TOTAL_SENT": "Envoyé",
    "TOTAL_STUDY_ANSWERS": "Réponses enquête",
    "TOTAL_USERS": "Utilisateurs inscrits",
    "TOTAL_VOTERS": "Votants",
    "TOTAL_VOTES": "Votes",
    "UNIQUE_VISITS": "Visites uniques",
    "USERS_WHO_ANSWERED": "{count} {count, plural, =0 {répondant} one {répondant} other {répondants}}",
    "USERS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Actions réalisées par les utilisateurs",
      "TOTAL_COMMENTS": "Commente",
      "TOTAL_IDEAS": "Fait une contribution",
      "TOTAL_NO_ACTIONS": "Aucune action",
      "TOTAL_STUDY_ANSWERS": "Réponses enquête",
      "TOTAL_VOTES": "Vote"
    },
    "WEEK": "Semaine",
    "WORD_CLOUD": "Nuage de mots"
  },
  "TEXT_FIELD": {
    "LENGTH": "{length}/{maxLength}",
    "LENGTH_ERROR": "{length}/{maxLength} - Vous avez dépassé la limite de caractères.",
    "LENGTH_ERROR_TEXT": "Vous avez dépassé la limite de caractères."
  },
  "TOGGLE_POSTS_VIEW": {
    "BUTTON_CAROUSEL": "Carrousel",
    "BUTTON_GROUP": "Changer de mode d’affichage",
    "BUTTON_LIST": "Liste",
    "BUTTON_MAP": "Carte"
  },
  "TOKENS": "{count, plural, =0 {Aucun jeton} one {{count} jeton} other {{count} jetons}}",
  "TOPIC_FORM": {
    "ADD_TOPIC": "Ajouter une thématique",
    "DESTROY_WARNING_DIALOG": {
      "DESCRIPTION_1": "Un ou plusieurs contenus de votre plateforme sont actuellement catégorisés sous cette thématique.",
      "DESCRIPTION_2": "En la modifiant ou en la supprimant, vous changerez la classification de ces contenus.",
      "TITLE": "Êtes-vous sur ?"
    }
  },
  "TRANSLATION": {
    "REVERSE_TRANSLATE": "Voir le texte d’origine",
    "SUCCESS": "La traduction a été effectuée avec succès.",
    "TRANSLATE": "Traduire",
    "TRANSLATING": "Traduction en cours…"
  },
  "UI_SECTION": {
    "FORM": {
      "ABOUT": {
        "SECTION_DESCRIPTION": "Les blocs permettent de personnaliser votre page en mettant en avant des informations format texte, image et vidéo.",
        "SECTION_HEADER": "Blocs"
      },
      "HOME": {
        "SECTION_DESCRIPTION": "Les blocs permettent de personnaliser votre page en mettant en avant des informations format texte, image, vidéo ainsi que les contenus à la une.",
        "SECTION_HEADER": "Blocs"
      },
      "ITEMS": {
        "ANOMALY_FORM": {
          "DESCRIPTION": "Signalement d’un problème en privé",
          "TITLE": "Anomalie"
        },
        "CUSTOM_BLOCK": {
          "DESCRIPTION": "Texte, image et vidéo",
          "TITLE": "Personnalisé"
        },
        "DEMAND_FORM": {
          "DESCRIPTION": "Contact privé via la plateforme",
          "TITLE": "Messagerie"
        },
        "FEATURED_CONSULTATIONS": {
          "DESCRIPTION": "Consultation à la une, en cours et à venir",
          "TITLE": "Consultation"
        },
        "FEATURED_NEWS": {
          "DESCRIPTION": "Article et événement",
          "TITLE": "Actualité"
        },
        "FOLDERS": {
          "DESCRIPTION": "Dossier et sous-dossier",
          "TITLE": "Dossier"
        },
        "KPIS": {
          "DESCRIPTION": "Nombre d’inscrits, de contributions et consultations",
          "TITLE": "Quelques chiffres"
        },
        "LATEST_IDEAS": {
          "DESCRIPTION": "Participation des utilisateurs",
          "TITLE": "Contribution"
        },
        "SPACE_INFO": {
          "TITLE": "Bandeau supérieur"
        }
      },
      "LAYER_ADD_MEDIA": "Ajouter un média",
      "LAYER_ADD_PICTURE": "Image",
      "LAYER_ADD_VIDEO": "Vidéo",
      "LAYER_ALIGNMENT": {
        "CENTER": {
          "DESCRIPTION": "Les textes sont centrés par rapport au média",
          "LABEL": "Centré"
        },
        "LEFT": {
          "DESCRIPTION": "Les textes sont à gauche du média",
          "LABEL": "À gauche"
        },
        "RIGHT": {
          "DESCRIPTION": "Les textes sont à droite du média",
          "LABEL": "À droite"
        },
        "TITLE": "Affichage"
      },
      "LAYER_COMMUNICATION_TYPE": {
        "ALL": "Toutes les actualités",
        "ARTICLE": "Article",
        "EVENT": "Événement",
        "LABEL": "Type",
        "PINNED": "À la une"
      },
      "LAYER_CONSULTATION_TYPE": {
        "ALL": "Toutes les consultations",
        "ENDED": "Consultations terminées",
        "LABEL": "Type",
        "ONGOING": "Consultations en cours",
        "PINNED": "À la une"
      },
      "LAYER_COUNTERS": {
        "CONSULTATIONS_COUNT": "Consultations lancées",
        "CONTRIBUTIONS_COUNT": "Contributions concrétisées",
        "PARTICIPATIONS_COUNT": "Participations (contributions, réponses d’enquêtes, votes et commentaires déposés)",
        "TITLE": "Afficher le nombre de :",
        "USERS_AND_PARTICIPATIONS_COUNT": "Inscrits et participations",
        "USERS_COUNT": "Inscrits"
      },
      "LAYER_CTA_LABEL": "Label du bouton",
      "LAYER_CTA_LABEL_PLACEHOLDER": "Ce que vous voulez afficher sur le bouton",
      "LAYER_CTA_URL": "Url du bouton",
      "LAYER_CTA_URL_PLACEHOLDER": "Lien vers une page ou un document",
      "LAYER_DESCRIPTION_LABEL": "Description",
      "LAYER_DESCRIPTION_PLACEHOLDER": "Ajoutez ici le contenu textuel du bloc. Soyez concis et percutant.",
      "LAYER_FILTERING_TYPE": {
        "ALL": "Tous les dossiers",
        "CHILDREN": "Contenus d’un dossier",
        "CUSTOM": "Personnalisé",
        "SELECT_FOLDER": "Sélectionner un dossier",
        "SELECT_FOLDERS": "Sélectionner les dossiers",
        "TYPE_LABEL": "Type de filtrage"
      },
      "LAYER_PICTURE_LABEL": "Image",
      "LAYER_TITLE_LABEL": "Titre",
      "LAYER_TITLE_PLACEHOLDER": "Définissez un titre pour le bloc",
      "SELECTION_DIALOG": {
        "TITLE": "Créer un bloc"
      }
    }
  },
  "USERS": {
    "ACTIONS_MENU": {
      "CONTACT_USER": "Contacter l’utilisateur",
      "INVITE": "Inviter",
      "UNREGISTER": "Désinscrire",
      "UPDATE_ROLE": "Définir le rôle"
    },
    "EXPORT": "Export des données utilisateurs",
    "EXPORT_SUCCESS_TOAST": "L’export est en cours. Vous recevrez un e-mail dès qu’il sera prêt.",
    "INVITATIONS": {
      "CREATE_FORM": {
        "EMAILS_LABEL": "Liste des emails séparés par des virgules",
        "EMAILS_PLACEHOLDER": "Exemple : utilisateur1@organisation.com, utilisateur2@association.org",
        "MESSAGE_LABEL": "Message d’invitation",
        "MESSAGE_PLACEHOLDER": "Saisissez un message d’invitation court et inspirant, qui donnera aux invités l’envie de rejoindre votre espace et de participer.",
        "SUCCESS_TOAST": "Les utilisateurs ont été invités avec succès.",
        "TITLE": "Inviter des utilisateurs",
        "WARNING": "Assurez-vous d’avoir obtenu le consentement des utilisateurs avant d’utiliser leur email pour les inviter."
      },
      "DELETE_FORM": {
        "CONTENT": "Vous êtes sur le point d’annuler l’invitation envoyée à <b>{email}</b>. Êtes-vous certain de vouloir continuer ?",
        "DELETE": "Supprimer",
        "TITLE": "Supprimer l’invitation"
      }
    },
    "UNREGISTER": {
      "DESCRIPTION_1": "Vous êtes sur le point de désinscrire l’utilisateur “<strong>{userName}</strong>” de votre espace de participation.",
      "DESCRIPTION_2": "Si l’espace est privé, l’utilisateur concerné ne pourra plus accéder à l’espace. Vous devrez le ré-inviter pour annuler cette opération.",
      "DESCRIPTION_3": "Si l’espace est public, l’utilisateur concerné ne pourra plus participer. Il devra se ré-inscrire pour annuler cette opération.",
      "DESCRIPTION_4": "Êtes-vous certain de vouloir procéder à l’opération ?",
      "TITLE": "Désinscrire l’utilisateur"
    }
  },
  "USER_AVATAR": "Avatar de l’utilisateur",
  "USER_VOTES_INFO": {
    "MAX_VOTES_ERROR": "Vous avez atteint le nombre maximum de votes",
    "MAX_VOTES_WARNING": "{count, plural, =0 {Vous ne pouvez pas soutenir plus de contributions} one {Vous pouvez soutenir <strong># contribution</strong> supplémentaire.} other {Vous pouvez soutenir <strong># contributions</strong> supplémentaires.}}",
    "MIN_VOTES_WARNING": "{count, plural, =0 {Vous soutenez assez de contributions} one {Encore <strong># soutien</strong> pour valider votre participation.} other {Encore <strong># soutiens</strong> pour valider votre participation.}}",
    "VALID_PARTICIPATION": "Votre participation est validée."
  },
  "VIEW_ALL": "Voir tout",
  "VIRUS_SCAN": {
    "CLEAN": "Analyse antivirus ok",
    "INFECTED": "Fichier infecté",
    "INFECTED_ATTACHMENTS_ERROR": "Un document semble infecté. Veuillez le supprimer avant de sauvegarder.",
    "NO_SCAN": "Analyse antivirus en cours"
  },
  "VOTERS": {
    "DUPLICATES": {
      "CARD": {
        "BIRTHDATE": "Date de naissance : {birthdate}",
        "DELETE_VOTE": "Supprimer le vote",
        "EMPTY": "Non renseignée",
        "IMPORTED_AT": "Importé le {date}",
        "KEEP_BOTH": "Conserver les deux",
        "PARTICIPATED_AT": "Participation le {date}"
      },
      "DESCRIPTION": "L’analyse des doublons prend en compte le nom et le prénom des utilisateurs. Pour traiter le doublon, choisissez le vote que vous souhaitez supprimer parmi les deux participations.",
      "FOUND_DUPLICATES": "Vous avez <b>{count, plural, one {{count} votant identifié doublon} other {{count} votants identifiés doublons}}</b>. Dernière mise à jour <b>{timeAgo}</b>",
      "LOADING": "Vérification en cours…",
      "NO_DUPLICATES": "Aucun doublon identifié. Dernière mise à jour <b>{timeAgo}</b>",
      "PLACEHOLDER": "Vous retrouverez ici les votants identifiés comme doublons.",
      "REFRESH": "Actualiser",
      "START_CHECK": "Lancer la vérification",
      "TITLE": "Gérer les doublons"
    }
  },
  "WYSIWYG": {
    "LINK_PROMPT": {
      "ENTER_URL": "Entrez l'URL"
    },
    "PLACEHOLDER": "Commencez à taper..."
  }
}